/* ============================================================
   Klantvijvers, Vijvercentrum.nl
   Client-logica voor de galerij (/pages/klantvijvers) en het
   insturen-formulier (/pages/klantvijvers-insturen).

   Vanilla JS, geen framework, defer-safe: initialisatie draait
   pas na DOMContentLoaded en alleen als de bijbehorende sectie
   op de pagina staat.

   AUTH (besluit Kees 18-10-2026, B-2026-10-18-5): de klant logt in
   met het eigen Shopify-klantaccount en elke call gaat same-origin
   via de Shopify App Proxy /apps/vp/klantvijvers/<naam> naar
   business.retailz.io (rz2-klant-ingang). Shopify zet er de
   handtekening en logged_in_customer_id bij; de server leest de klant
   daaruit. Er is geen handtekening in de pagina, geen geheim en geen
   rechtstreekse call naar een externe API meer. Insturen kan ook
   zonder account (e-mail in het formulier, besluit 17-07); stemmen,
   reageren, melden en mijn vragen een ingelogde klant.

   CONFIG: de secties injecteren via Liquid CUSTOMER_LOGGED_IN,
   CUSTOMER_FIRST_NAME en ACCOUNT_LOGIN_URL in
   window.KLANTVIJVERS_CONFIG. Lege strings worden genegeerd, zodat de
   defaults hieronder blijven gelden.
   ============================================================ */
(function () {
  'use strict';

  /* Een keer per pagina: staat het script twee keer op de pagina (twee
     secties), dan zou alles dubbel initialiseren en dubbel meten. */
  if (window.__kvGeladen) return;
  window.__kvGeladen = true;

  /* ========================= CONFIG ========================= */
  var DEFAULT_CONFIG = {
    /* Basis-pad van de Shopify App Proxy op het eigen domein:
       /apps/vp is de proxy naar business.retailz.io (B-2026-10-18-5) */
    PROXY_BASE: '/apps/vp/klantvijvers',
    /* Door de secties via Liquid geinjecteerd: is er een klant
       ingelogd, wat is de voornaam, en waar is de inlogpagina */
    CUSTOMER_LOGGED_IN: false,
    CUSTOMER_FIRST_NAME: '',
    ACCOUNT_LOGIN_URL: '/account/login',
    PER_PAGE: 12,          /* kaarten per pagina */
    MAX_FOTOS: 6,          /* max aantal foto's per inzending */
    MAX_AFMETING: 1920,    /* langste zijde na client-side resize */
    JPEG_KWALITEIT: 0.85,
    CONSENT_VERSIE: '2026-07',
    VERHAAL_MAX: 2000
  };

  /* Theme-settings overschrijven defaults, maar lege waarden niet */
  var userCfg = window.KLANTVIJVERS_CONFIG || {};
  Object.keys(userCfg).forEach(function (k) {
    if (userCfg[k] === '' || userCfg[k] === null || userCfg[k] === undefined) delete userCfg[k];
  });
  var CONFIG = Object.assign({}, DEFAULT_CONFIG, userCfg);
  /* Een opgeslagen themawaarde van voor 19-10-2026 (/apps/klantvijvers,
     de oude App Proxy die niet meer bestaat) wint nooit. */
  CONFIG.PROXY_BASE = DEFAULT_CONFIG.PROXY_BASE;

  /* Relatief pad via de Shopify App Proxy op het eigen domein. Shopify
     voegt shop, timestamp, signature en logged_in_customer_id toe. De
     namen zijn het contract met de ingang: gallery, submit, vote,
     comment, report, maandShortlist, jaarStemronde, jaarStem, mijn,
     verwijder, notificatie. */
  function endpoint(naam) {
    return CONFIG.PROXY_BASE.replace(/\/+$/, '') + '/' + naam;
  }

  /* ========================= HELPERS ========================= */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ========================= METEN (GA4) =========================
     Meetplan (21-10-2026): docs/meten/klantvijvers.md. Elke stap van de
     klantreis is een GA4-gebeurtenis kv_* via de gtag van het thema
     (G-9HQRM66093 via data.vijvercentrum.nl). De regels zijn die van vp_*
     in assets/mijn-vijver-link.js:
     - alleen na toestemming voor analytics (Shopify Customer Privacy API),
       nooit bij Global Privacy Control en nooit in de thema-editor;
     - is de keuze nog niet bekend (de API laadt pas na DOMContentLoaded, of
       de banner staat nog open), dan wacht de gebeurtenis in een rij en gaat
       hij alsnog mee zodra de bezoeker toestemt; bij een weigering vervalt
       de rij. Tot 21-10 gingen kv_galerij_view en kv_insturen_view direct bij
       het laden weg, voor de keuze bekend was;
     - alleen namen uit MEET_EVENTS en parameters uit MEET_PARAMS, met korte
       vaste waarden: nooit e-mail, naam, woonplaats of verhaaltekst. Een
       waarde met een @ of langer dan 100 tekens valt weg;
     - elke gebeurtenis krijgt kv_versie, kv_pagina en kv_ingelogd (ja/nee);
     - meten mag nooit iets breken: alles in try/catch. */
  var MEET_VERSIE = 'kv-meet-1';
  var MEET_PAGINA = '';
  var MEET_EVENTS = {
    kv_galerij_view: 1, kv_filter: 1, kv_inzending_open: 1, kv_stem: 1, kv_reactie: 1, kv_deel: 1,
    kv_insturen_view: 1, kv_insturen_start: 1, kv_foto_toegevoegd: 1, kv_verhaal_hulp: 1,
    kv_techniek_eerder_besteld: 1, kv_techniek_snelkeuze: 1,
    kv_verstuur_poging: 1, kv_verstuur_fout: 1, kv_insturen_klaar: 1,
    kv_bewerk_start: 1, kv_bewerking_opgeslagen: 1,
    kv_bedank_getoond: 1, kv_verhaal_toegevoegd: 1, kv_verhaal_overgeslagen: 1, kv_aanvul_geopend: 1,
    kv_login_getoond: 1, kv_login_gestart: 1, kv_login_gelukt: 1, kv_fout: 1
  };
  var MEET_PARAMS = {
    kv_versie: 1, kv_pagina: 1, kv_ingelogd: 1, kv_bron: 1, kv_reden: 1, kv_type: 1, kv_aantal: 1,
    kv_bewerkt: 1, kv_status: 1, kv_inzending: 1, kv_filter: 1, kv_waarde: 1, kv_kanaal: 1
  };
  var BRON_RE = /^[a-z0-9][a-z0-9_-]{0,39}$/;
  var meetRij = [];
  var meetLuistert = false;
  var meetTimer = null;

  /* 'ja', 'nee' of 'onbekend' (API nog niet geladen of nog geen keuze) */
  function meetKeuze() {
    try {
      if (window.navigator && window.navigator.globalPrivacyControl === true) return 'nee';
      if (window.Shopify && window.Shopify.designMode) return 'nee';
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return 'onbekend';
      if (cp.analyticsProcessingAllowed() === true) return 'ja';
      var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return c && c.analytics === '' ? 'onbekend' : 'nee';
    } catch (e) { return 'nee'; }
  }

  function meetSchoon(params) {
    var uit = {};
    Object.keys(params || {}).forEach(function (k) {
      if (!MEET_PARAMS[k]) return;
      var v = params[k];
      if (typeof v === 'number') { if (isFinite(v)) uit[k] = v; return; }
      if (typeof v === 'boolean') { uit[k] = v ? 'ja' : 'nee'; return; }
      if (typeof v !== 'string') return;
      v = v.replace(/\s+/g, ' ').trim();
      if (!v || v.length > 100 || v.indexOf('@') !== -1) return;
      uit[k] = v;
    });
    return uit;
  }

  function meetLeeg(stuur) {
    var rij = meetRij.splice(0, meetRij.length);
    if (!stuur || typeof window.gtag !== 'function') return;
    rij.forEach(function (e) {
      try { window.gtag('event', e.naam, e.params); } catch (x) { /* meten mag nooit iets breken */ }
    });
  }

  /* Wachten op de keuze: de API laden (Shopify dedupliceert), 10 seconden
     kijken, en daarna nog luisteren naar visitorConsentCollected. Die luisteraar
     staat na die van layout/theme.liquid, dus gtag heeft de nieuwe stand al. */
  function meetWacht() {
    if (!meetLuistert) {
      meetLuistert = true;
      document.addEventListener('visitorConsentCollected', function (ev) {
        var k = meetKeuze();
        var d = ev && ev.detail;
        if (k === 'onbekend' && d && typeof d.analyticsAllowed === 'boolean') k = d.analyticsAllowed ? 'ja' : 'nee';
        if (k !== 'onbekend') meetLeeg(k === 'ja');
      });
      try {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
            var k = meetKeuze();
            if (k !== 'onbekend') meetLeeg(k === 'ja');
          });
        }
      } catch (x) { /* stil */ }
    }
    if (meetTimer) return;
    var pogingen = 0;
    meetTimer = setInterval(function () {
      var k = meetKeuze();
      if (k !== 'onbekend' || ++pogingen >= 40 || !meetRij.length) {
        clearInterval(meetTimer);
        meetTimer = null;
        if (k !== 'onbekend') meetLeeg(k === 'ja');
      }
    }, 250);
  }

  function meet(naam, params) {
    try {
      if (!MEET_EVENTS[naam]) return false;
      var p = meetSchoon(params);
      p.kv_versie = MEET_VERSIE;
      if (!p.kv_pagina && MEET_PAGINA) p.kv_pagina = MEET_PAGINA;
      p.kv_ingelogd = CONFIG.CUSTOMER_LOGGED_IN ? 'ja' : 'nee';
      p.transport_type = 'beacon';
      var k = meetKeuze();
      if (k === 'nee') { meetRij.length = 0; return false; }
      if (meetRij.length < 50) meetRij.push({ naam: naam, params: p });
      if (k === 'ja') { meetLeeg(true); return true; }
      meetWacht();
      return false;
    } catch (x) { return false; }
  }

  /* Herkomst uit ?bron= (productgrid, vijvercheck, kortingscode, mail, ...) */
  function meetBron() {
    try {
      var b = new URLSearchParams(window.location.search).get('bron') || '';
      if (!b) return '';
      return BRON_RE.test(b) ? b : 'onbekend';
    } catch (e) { return ''; }
  }

  /* Vaste reden bij een fout: auth, dubbel, limiet, netwerk, server_<status> */
  function meetReden(err) {
    if (!err) return 'onbekend';
    if (err.code === 'server') return 'server_' + (err.status || 'onbekend');
    return String(err.code || 'onbekend');
  }

  /* Voor de volgende stap van de klantreis (verhaal later) en de toetsen. */
  var VERHAAL_BRON = { bedankscherm: 1, mail: 1 };
  function verhaalBron(b) { return VERHAAL_BRON[b] ? b : 'onbekend'; }
  window.KlantvijversMeting = {
    versie: MEET_VERSIE,
    keuze: meetKeuze,
    meet: meet,
    bedankGetoond: function (bron) { return meet('kv_bedank_getoond', { kv_bron: bron || 'insturen' }); },
    verhaalToegevoegd: function (bron) { return meet('kv_verhaal_toegevoegd', { kv_bron: verhaalBron(bron) }); },
    verhaalOvergeslagen: function (bron) { return meet('kv_verhaal_overgeslagen', { kv_bron: verhaalBron(bron) }); },
    aanvulGeopend: function (bron) { return meet('kv_aanvul_geopend', { kv_bron: bron || meetBron() || 'direct' }); }
  };

  /* HTML-escapen zodat API-data nooit als markup rendert */
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Inzendingstypen (besluit Kees 13-07-2026): wat laat de klant
     zien. Waarden zijn het contract met klantvijvers-submit en
     -gallery (kolom inzending_type); labels zijn de klantcopy. */
  var TYPE_LABELS = {
    vijver: 'Mijn vijver',
    koi: 'Mijn koi en vissen',
    design: 'Design en aanleg',
    tuin: 'Tuin totaal'
  };

  function typeBadge(type) {
    var label = TYPE_LABELS[type];
    if (!label) return '';
    return '<span class="kv-badge kv-badge-type">' + esc(label) + '</span>';
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function fmtGeld(cents) {
    return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
  }

  function fmtVolume(liter) {
    if (!liter) return '';
    return Number(liter).toLocaleString('nl-NL') + ' L';
  }

  function fmtDatum(iso) {
    try {
      return new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) { return ''; }
  }

  /* localStorage met try/catch, Safari private mode gooit anders errors */
  var opslag = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* stil */ } }
  };

  /* Nette fout met Nederlandse melding voor de gebruiker */
  function KvError(bericht, code) {
    var err = new Error(bericht);
    err.kv = true;
    err.code = code || 'algemeen';
    return err;
  }

  /* Toast: korte statusmelding onderin beeld */
  var toastTimer = null;
  function toast(bericht, type) {
    var el = qs('.kv-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'kv-root kv-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = bericht;
    el.dataset.type = type || 'info';
    el.classList.add('kv-toast-zichtbaar');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('kv-toast-zichtbaar'); }, 4200);
  }

  /* ========================= SHOPIFY LOGIN =========================
     De klant logt in met het eigen Vijvercentrum-klantaccount. De sectie
     injecteert via Liquid of er een klant is ingelogd, de voornaam en de
     inlog-URL. De App Proxy-signature bewijst de login bij de server. */

  /* Inlog-URL met return naar de huidige pagina */
  function loginUrlMetReturn(serverLoginUrl) {
    /* Gedocumenteerd Shopify-patroon (Sign-in redirects, 23-07-2026):
       /customer_authentication/login?return_to=<relatief pad> stuurt de
       klant na het inloggen terug naar precies deze pagina. De
       login-stap zelf gebruikt routes.storefront_login_url via Liquid. */
    var pad = window.location.pathname + window.location.search;
    return '/customer_authentication/login?return_to=' + encodeURIComponent(pad);
  }

  /* Nette dialoog: log in met je Vijvercentrum-account */
  var loginDialoogEl = null;
  /* Meetplan: waarom de inlogpoort verscheen (stem, reactie, melden,
     jaarstem, mijn, verwijder, insturen) en of de klant daarna inlogde. */
  var loginMeetReden = '';
  var loginGestart = false;
  function meetLoginGestart(reden) {
    loginMeetReden = reden || loginMeetReden || 'onbekend';
    loginGestart = true;
    meet('kv_login_gestart', { kv_reden: loginMeetReden });
  }
  function toonLoginDialoog(redenTekst, serverLoginUrl, redenCode) {
    loginMeetReden = redenCode || 'onbekend';
    meet('kv_login_getoond', { kv_reden: loginMeetReden });
    if (!loginDialoogEl) {
      loginDialoogEl = document.createElement('div');
      loginDialoogEl.className = 'kv-root kv-overlay kv-login-overlay';
      loginDialoogEl.hidden = true;
      document.body.appendChild(loginDialoogEl);
      loginDialoogEl.addEventListener('click', function (e) {
        if (e.target === loginDialoogEl || e.target.closest('[data-kv-login-sluit]')) {
          loginDialoogEl.hidden = true;
          document.body.classList.remove('kv-scroll-vast');
        }
      });
    }
    loginDialoogEl.innerHTML =
      '<div class="kv-modal kv-otp-modal kv-login-modal" role="dialog" aria-modal="true" aria-label="Inloggen met je Vijvercentrum-account">' +
        '<button type="button" class="kv-modal-sluit" data-kv-login-sluit aria-label="Sluiten">&times;</button>' +
        '<h3 class="kv-otp-titel">Log in met je Vijvercentrum-account</h3>' +
        '<p class="kv-otp-reden">' + esc(redenTekst || 'Log in om verder te gaan.') + '</p>' +
        '<a class="kv-knop kv-knop-primair" href="' + esc(loginUrlMetReturn(serverLoginUrl)) + '" target="_blank" rel="noopener" data-kv-login-ga>Inloggen of account aanmaken</a>' +
        '<p class="kv-otp-privacy">Inloggen opent in een nieuw tabblad, dus alles wat je hier al invulde blijft staan. Zodra je ingelogd bent gaat het hier vanzelf verder.</p>' +
      '</div>';
    loginDialoogEl.hidden = false;
    document.body.classList.add('kv-scroll-vast');
    var gaKnop = loginDialoogEl.querySelector('[data-kv-login-ga]');
    if (gaKnop) gaKnop.addEventListener('click', function () { meetLoginGestart(); startLoginPolling(); });
  }

  /* Zodra de klant (in het andere tabblad) is ingelogd: dialoog sluiten
     en laten weten dat hij gewoon verder kan. */
  document.addEventListener('kv-auth-changed', function (e) {
    if (e.detail && e.detail.logged_in && loginGestart) {
      loginGestart = false;
      meet('kv_login_gelukt', { kv_reden: loginMeetReden || 'onbekend' });
    }
    if (e.detail && e.detail.logged_in && loginDialoogEl && !loginDialoogEl.hidden) {
      loginDialoogEl.hidden = true;
      document.body.classList.remove('kv-scroll-vast');
      toast('Je bent ingelogd! Ga gewoon verder waar je was.');
    }
  });

  /* ================= VERSE AUTH (23-07-2026, 19-10-2026) =================
     De paginastate kan achterlopen op de echte loginstatus (de klant
     logt in een ander tabblad of op een ander scherm in). Daarom halen
     we op het moment van de actie de loginstatus op via de Section
     Rendering API (sectie kv-verse-auth, per request gerenderd, alleen
     logged_in en de voornaam). Wisselt de status, dan vuurt het
     document-event 'kv-auth-changed' zodat de UI meteen meebeweegt. */
  var versAuthBezig = null;
  var versAuthOp = 0;
  function versAuth(forceer) {
    if (!forceer && Date.now() - versAuthOp < 60 * 1000) {
      return Promise.resolve(!!CONFIG.CUSTOMER_LOGGED_IN);
    }
    if (versAuthBezig) return versAuthBezig;
    versAuthBezig = fetch('/?sections=kv-verse-auth', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data && data['kv-verse-auth'];
        var m = html && html.match(/data-kv-verse-auth[^>]*>\s*([\s\S]*?)\s*<\/script>/);
        if (!m) throw new Error('kv-verse-auth ontbreekt');
        var nieuw = JSON.parse(m[1]);
        var was = !!CONFIG.CUSTOMER_LOGGED_IN;
        CONFIG.CUSTOMER_LOGGED_IN = !!nieuw.logged_in;
        if (nieuw.logged_in && nieuw.first_name) CONFIG.CUSTOMER_FIRST_NAME = nieuw.first_name;
        versAuthOp = Date.now();
        if (was !== !!CONFIG.CUSTOMER_LOGGED_IN) {
          document.dispatchEvent(new CustomEvent('kv-auth-changed', { detail: { logged_in: !!CONFIG.CUSTOMER_LOGGED_IN } }));
        }
        return !!CONFIG.CUSTOMER_LOGGED_IN;
      })
      .catch(function () { return !!CONFIG.CUSTOMER_LOGGED_IN; /* fail-open op de bestaande state */ })
      .finally(function () { versAuthBezig = null; });
    return versAuthBezig;
  }

  /* Polling na 'inloggen in nieuw tabblad':check elke 4 seconden de status
     tot de klant ingelogd is (max 5 minuten), plus een directe check
     zodra dit tabblad weer zichtbaar wordt. */
  var loginPollTimer = null;
  function startLoginPolling() {
    stopLoginPolling();
    var start = Date.now();
    loginPollTimer = setInterval(function () {
      if (Date.now() - start > 5 * 60 * 1000) { stopLoginPolling(); return; }
      versAuth(true).then(function (ingelogd) { if (ingelogd) stopLoginPolling(); });
    }, 4000);
  }
  function stopLoginPolling() {
    if (loginPollTimer) { clearInterval(loginPollTimer); loginPollTimer = null; }
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !CONFIG.CUSTOMER_LOGGED_IN) versAuth(true);
  });

  /* ========================= FETCH-WRAPPER ========================= */
  function apiFetch(url, opties) {
    opties = Object.assign({ credentials: 'same-origin' }, opties || {});
    /* metStatus (meetplan 21-10-2026): resolve met { status, data } in plaats
       van alleen de data, zodat de meting kan zien of het echt een 201 was. */
    var metStatus = !!opties.metStatus;
    delete opties.metStatus;
    return fetch(url, opties).catch(function () {
      throw KvError('Geen verbinding. Controleer je internet en probeer het opnieuw.', 'netwerk');
    }).then(function (res) {
      if (res.status === 401 || res.status === 403) {
        /* Server stuurt { error: 'login_vereist', login_url }; nette
           login-dialoog tonen en de actie als auth-fout laten falen */
        return res.json().catch(function () { return {}; }).then(function (body) {
          /* Een aanvullink uit de mail met een verkeerde token is geen
             loginprobleem: de route werkt zonder login (21-10-2026). */
          if (body && body.code === 'ongeldige_link') {
            var l = KvError('Deze link klopt niet. Gebruik de knop uit je mail, of app ons even.', 'link');
            l.status = res.status;
            throw l;
          }
          /* Dialoog niet hier tonen: apiFetchAuth probeert eerst stil een
             verse signature (23-07-2026) en toont de dialoog pas als de
             klant echt niet ingelogd blijkt. */
          var e = KvError('Log eerst in met je Vijvercentrum-account.', 'auth');
          e.login_url = body.login_url;
          throw e;
        });
      }
      if (res.status === 409) throw KvError('Je hebt al gestemd op deze vijver.', 'dubbel');
      if (res.status === 429) throw KvError('Je hebt net een paar keer ingestuurd. Probeer het over een uurtje nog eens.', 'limiet');
      if (res.status === 204) return metStatus ? { status: 204, data: null } : null;
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          var e = KvError(body.message || body.error || 'Er ging iets mis. Probeer het zo opnieuw.', 'server');
          e.status = res.status;
          throw e;
        });
      }
      return res.json().catch(function () { return null; }).then(function (data) {
        return metStatus ? { status: res.status, data: data } : data;
      });
    });
  }

  /* Ingelogde variant. De storefront-cookie is de sessie; de App Proxy
     zet logged_in_customer_id in het verzoek en de server leest de klant
     daaruit. Voor de call een verse loginstatus (de klant kan in een
     ander tabblad inloggen of uitloggen); bij een 401 een keer stil
     opnieuw kijken voordat de login-dialoog verschijnt. */
  var LOGIN_REDEN = { vote: 'stem', comment: 'reactie', report: 'melden', jaarStem: 'jaarstem', mijn: 'mijn', verwijder: 'verwijder', submit: 'insturen', notificatie: 'notificatie' };
  function loginRedenVoor(url) {
    return LOGIN_REDEN[String(url || '').split('?')[0].split('/').pop()] || 'onbekend';
  }

  function apiFetchAuth(url, opties) {
    var reden = loginRedenVoor(url);
    return versAuth().then(function (ingelogd) {
      if (!ingelogd) {
        toonLoginDialoog('Log in met je Vijvercentrum-account om verder te gaan.', null, reden);
        throw KvError('Log eerst in met je Vijvercentrum-account.', 'auth');
      }
      return apiFetch(url, opties).catch(function (err) {
        if (!err || err.code !== 'auth') throw err;
        return versAuth(true).then(function (nogIngelogd) {
          if (!nogIngelogd) {
            toonLoginDialoog('Log in met je Vijvercentrum-account om verder te gaan.', err.login_url, reden);
            throw err;
          }
          return apiFetch(url, opties).catch(function (err2) {
            if (err2 && err2.code === 'auth') {
              toonLoginDialoog('Log in met je Vijvercentrum-account om verder te gaan.', err2.login_url, reden);
            }
            throw err2;
          });
        });
      });
    });
  }

  /* ========================= LOGIN-VRAAG =========================
     Ingelogd = direct door; anders de login-dialoog tonen en de actie
     annuleren (inloggen opent in een nieuw tabblad, de pagina gaat daarna
     vanzelf verder). */
  function vraagLogin(redenTekst, redenCode) {
    if (CONFIG.CUSTOMER_LOGGED_IN) return Promise.resolve(true);
    toonLoginDialoog(redenTekst, null, redenCode);
    return Promise.reject(KvError('Inloggen geannuleerd.', 'geannuleerd'));
  }

  /* ========================= FOTO-RESIZE =========================
     Client-side verkleinen naar max 1920px langste zijde via canvas.
     EXIF-rotatie wordt door createImageBitmap gecorrigeerd. */
  function verkleinFoto(bestand) {
    return laadBitmap(bestand).then(function (bmp) {
      var schaal = Math.min(1, CONFIG.MAX_AFMETING / Math.max(bmp.width, bmp.height));
      var b = Math.round(bmp.width * schaal), h = Math.round(bmp.height * schaal);
      var canvas = document.createElement('canvas');
      canvas.width = b; canvas.height = h;
      canvas.getContext('2d').drawImage(bmp, 0, 0, b, h);
      if (bmp.close) bmp.close();
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          if (!blob) { reject(KvError('Deze foto kon niet verwerkt worden.')); return; }
          resolve(new File([blob], vervangExtensie(bestand.name), { type: 'image/jpeg' }));
        }, 'image/jpeg', CONFIG.JPEG_KWALITEIT);
      });
    });
  }

  function laadBitmap(bestand) {
    if (window.createImageBitmap) {
      return createImageBitmap(bestand, { imageOrientation: 'from-image' }).catch(function () {
        return createImageBitmap(bestand); /* oudere browsers zonder options-object */
      });
    }
    /* fallback via Image element */
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(bestand);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(KvError('Deze foto kon niet gelezen worden.')); };
      img.src = url;
    });
  }

  function vervangExtensie(naam) {
    return String(naam || 'foto').replace(/\.[^.]+$/, '') + '.jpg';
  }

  /* ========================= GEAR-CARDS =========================
     Product-handles uit de gear-lijst renderen als echte Shopify
     product-cards via het publieke /products/HANDLE.js endpoint.
     Handles komen runtime uit de API, daarom fetch en geen render-tag. */
  var gearCache = {};
  function laadProduct(handle) {
    if (!gearCache[handle]) {
      gearCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) { if (!res.ok) throw new Error('404'); return res.json(); })
        .catch(function () { return null; }); /* product weg = kaart stil overslaan */
    }
    return gearCache[handle];
  }

  function renderGearLijst(container, handles) {
    if (!handles || !handles.length) {
      container.innerHTML = '<p class="kv-muted">Geen techniek opgegeven bij deze vijver.</p>';
      return;
    }
    container.innerHTML = '<p class="kv-muted">Techniek laden...</p>';
    Promise.all(handles.slice(0, 12).map(laadProduct)).then(function (producten) {
      var kaarten = producten.filter(Boolean).map(function (p) {
        var img = p.featured_image ? esc(p.featured_image) + (p.featured_image.indexOf('?') === -1 ? '?width=180' : '&width=180') : '';
        return '<a class="kv-gear-kaart" href="/products/' + esc(p.handle) + '">' +
          (img ? '<img class="kv-gear-foto" src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="90" height="90">' : '<span class="kv-gear-foto kv-gear-foto-leeg"></span>') +
          '<span class="kv-gear-info"><span class="kv-gear-naam">' + esc(p.title) + '</span>' +
          '<span class="kv-gear-prijs">' + fmtGeld(p.price) + '</span></span>' +
          '<span class="kv-gear-pijl" aria-hidden="true">&rsaquo;</span></a>';
      });
      container.innerHTML = kaarten.length
        ? '<div class="kv-gear-lijst">' + kaarten.join('') + '</div>'
        : '<p class="kv-muted">De gebruikte techniek is niet meer leverbaar.</p>';
    });
  }

  /* ========================= GALERIJ ========================= */
  function initGalerij(root) {
    var grid = qs('[data-kv-grid]', root);
    var meerKnop = qs('[data-kv-meer]', root);
    var sentinel = qs('[data-kv-sentinel]', root);
    var leegEl = qs('[data-kv-leeg]', root);
    var statusEl = qs('[data-kv-status]', root);

    var state = {
      filters: { type: '', vijvertype: '', volume: '', techniek: [], sort: 'nieuw' },
      page: 1, bezig: false, klaar: false, items: {}, totaal: 0
    };
    var gestemd = opslag.get('kv-gestemd') || {};

    /* Warme lege staat: alleen tonen bij echt 0 resultaten (nooit tijdens
       laden). Bij een actieve filtercombinatie de filter-variant, anders
       de uitnodiging om als eerste in te sturen. */
    function toonLegeStaat(leeg) {
      leegEl.hidden = !leeg;
      var onderCta = qs('[data-kv-onder-cta]', root);
      if (onderCta) onderCta.hidden = leeg;
      if (!leeg) return;
      var filtersActief = !!(state.filters.type || state.filters.vijvertype ||
        state.filters.volume || (state.filters.techniek && state.filters.techniek.length));
      var startEl = qs('[data-kv-leeg-start]', leegEl);
      var filterEl = qs('[data-kv-leeg-filter]', leegEl);
      if (startEl) startEl.hidden = filtersActief;
      if (filterEl) filterEl.hidden = !filtersActief;
    }

    /* -------- laden en renderen -------- */
    function bouwQuery() {
      var p = new URLSearchParams();
      p.set('page', state.page);
      p.set('per_page', CONFIG.PER_PAGE);
      p.set('sort', state.filters.sort);
      if (state.filters.type) p.set('type', state.filters.type);
      if (state.filters.vijvertype) p.set('vijvertype', state.filters.vijvertype);
      if (state.filters.volume) {
        var delen = state.filters.volume.split('-');
        if (delen[0]) p.set('volume_min', delen[0]);
        if (delen[1]) p.set('volume_max', delen[1]);
      }
      if (state.filters.techniek.length) p.set('techniek', state.filters.techniek.join(','));
      return p.toString();
    }

    function laad(reset) {
      if (state.bezig) return;
      if (reset) { state.page = 1; state.klaar = false; grid.innerHTML = ''; state.items = {}; leegEl.hidden = true; }
      if (state.klaar) return;
      state.bezig = true;
      statusEl.hidden = false;
      meerKnop.disabled = true;
      apiFetch(endpoint('gallery') + '?' + bouwQuery()).then(function (data) {
        var items = (data && data.items) || [];
        state.totaal = (data && data.total) || items.length;
        items.forEach(function (item) {
          state.items[item.id] = item;
          grid.insertAdjacentHTML('beforeend', renderKaart(item));
        });
        state.klaar = data ? data.has_more === false || items.length < CONFIG.PER_PAGE : true;
        state.page += 1;
        toonLegeStaat(!grid.children.length);
        meerKnop.hidden = state.klaar;
        if (state.page === 2) injectJsonLd(items, state.totaal);
      }).catch(function (err) {
        meet('kv_fout', { kv_bron: 'galerij', kv_reden: meetReden(err) });
        toast(err.kv ? err.message : 'De galerij kon niet laden. Probeer het zo opnieuw.', 'fout');
      }).finally(function () {
        state.bezig = false;
        statusEl.hidden = true;
        meerKnop.disabled = false;
      });
    }

    /* Iconen op de kaart (16-10-2026): inline SVG in plaats van emoji en
       unicode-hartjes, zodat ze overal hetzelfde ogen. Nul-tellers tonen we
       niet: een kaart met "0" oogt onbemind, "Stem" en "Reageer" nodigen uit. */
    var ICOON_HART = '<svg class="kv-icoon kv-icoon-hart" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7z"/></svg>';
    var ICOON_BERICHT = '<svg class="kv-icoon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z"/></svg>';
    var ICOON_TAG = '<svg class="kv-icoon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12.59 2.59A2 2 0 0 0 11.17 2H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.42l8.7 8.7a2.43 2.43 0 0 0 3.42 0l6.58-6.58a2.43 2.43 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r="1.25" fill="currentColor"/></svg>';
    function stemTekst(n) { return n > 0 ? String(n) : 'Stem'; }

    function renderKaart(item) {
      var foto = (item.media && item.media[0]) || '';
      var heeftGestemd = !!gestemd[item.id];
      var plaats = [item.voornaam, item.regio].filter(Boolean).join(' uit ');
      var stemmen = item.votes_count || 0;
      var reacties = item.comments_count || 0;
      var gear = (item.techniek || []).length;
      return '<article class="kv-kaart" data-kv-kaart="' + esc(item.id) + '">' +
        '<button type="button" class="kv-kaart-fotoknop" data-kv-open="' + esc(item.id) + '" aria-label="Bekijk ' + esc(item.titel) + '">' +
          (foto ? '<img class="kv-kaart-foto" src="' + esc(foto) + '" alt="' + esc(item.titel) + '" loading="lazy">' : '<span class="kv-kaart-foto kv-kaart-foto-leeg">Geen foto</span>') +
          (item.featured_maand ? '<span class="kv-badge kv-badge-featured">Vijver van de Maand</span>' : '') +
        '</button>' +
        '<div class="kv-kaart-body">' +
          '<h3 class="kv-kaart-titel"><button type="button" class="kv-kaart-titelknop" data-kv-open="' + esc(item.id) + '">' + esc(item.titel) + '</button></h3>' +
          (plaats ? '<p class="kv-kaart-plaats">' + esc(plaats) + '</p>' : '') +
          '<p class="kv-kaart-meta">' +
            typeBadge(item.inzending_type) +
            (item.vijvertype ? '<span class="kv-badge">' + esc(item.vijvertype) + '</span>' : '') +
            (item.volume_liter ? '<span class="kv-badge kv-badge-volume">' + fmtVolume(item.volume_liter) + '</span>' : '') +
          '</p>' +
          (gear ? '<button type="button" class="kv-gear-badge" data-kv-open="' + esc(item.id) + '">' + ICOON_TAG + gear + (gear === 1 ? ' product' : ' producten') + ' gekoppeld<span class="kv-vis-verborgen">, bekijk de techniek</span></button>' : '') +
          '<div class="kv-kaart-acties">' +
            '<button type="button" class="kv-stemknop' + (heeftGestemd ? ' kv-gestemd' : '') + '" data-kv-stem="' + esc(item.id) + '" aria-pressed="' + heeftGestemd + '">' +
              ICOON_HART +
              '<span data-kv-stemmen data-kv-aantal="' + stemmen + '">' + stemTekst(stemmen) + '</span>' +
              '<span class="kv-vis-verborgen">' + (stemmen === 1 ? ' stem' : ' stemmen') + '</span>' +
            '</button>' +
            '<button type="button" class="kv-reactieknop" data-kv-open="' + esc(item.id) + '">' +
              ICOON_BERICHT + (reacties > 0 ? reacties + '<span class="kv-vis-verborgen"> ' + (reacties === 1 ? 'reactie' : 'reacties') + '</span>' : 'Reageer') +
            '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    /* -------- stemmen (optimistic update) -------- */
    function stem(id, knop) {
      if (gestemd[id]) { toast('Je hebt al gestemd op deze vijver.'); return; }
      var teller = qs('[data-kv-stemmen]', knop);
      vraagLogin('Log in om te stemmen. Zo houden we het eerlijk: 1 stem per persoon.', 'stem').then(function () {
        /* optimistic: teller direct omhoog, terugdraaien bij fout */
        var oud = parseInt(teller.getAttribute('data-kv-aantal'), 10) || 0;
        var zetTeller = function (n) { teller.setAttribute('data-kv-aantal', n); teller.textContent = stemTekst(n); };
        zetTeller(oud + 1);
        knop.classList.add('kv-gestemd');
        knop.setAttribute('aria-pressed', 'true');
        gestemd[id] = true;
        opslag.set('kv-gestemd', gestemd);
        return apiFetchAuth(endpoint('vote'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ submission_id: id })
        }).then(function (data) {
          if (data && typeof data.votes_count === 'number') zetTeller(data.votes_count);
          meet('kv_stem', { kv_inzending: id, kv_bron: 'galerij' });
          toast('Bedankt voor je stem!');
        }).catch(function (err) {
          meet('kv_fout', { kv_bron: 'stem', kv_reden: meetReden(err) });
          if (err.code === 'dubbel') { toast(err.message); return; } /* al gestemd = teller laten staan op serverwaarde */
          zetTeller(oud);
          knop.classList.remove('kv-gestemd');
          knop.setAttribute('aria-pressed', 'false');
          delete gestemd[id];
          opslag.set('kv-gestemd', gestemd);
          toast(err.kv ? err.message : 'Stemmen mislukte. Probeer het opnieuw.', 'fout');
        });
      }).catch(function (err) {
        if (err.code !== 'geannuleerd') toast(err.message, 'fout');
      });
    }

    /* -------- detail-modal -------- */
    var modal = null, laatsteFocus = null;

    function openDetail(id, bron) {
      meet('kv_inzending_open', { kv_inzending: id, kv_bron: bron || 'kaart' });
      laatsteFocus = document.activeElement;
      var item = state.items[id];
      toonModal(item || null);
      /* detail altijd vers ophalen: reacties en actuele stemmen */
      apiFetch(endpoint('gallery') + '?id=' + encodeURIComponent(id)).then(function (data) {
        var vers = data && (data.item || data);
        if (vers && vers.id) { state.items[id] = vers; toonModal(vers); }
      }).catch(function () { /* kaartdata was al zichtbaar, stil laten */ });
    }

    function toonModal(item) {
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'kv-root kv-overlay kv-detail-overlay';
        document.body.appendChild(modal);
        modal.addEventListener('click', function (e) { if (e.target === modal) sluitModal(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) sluitModal(); });
      }
      modal.hidden = false;
      document.body.classList.add('kv-scroll-vast');
      if (!item) { modal.innerHTML = '<div class="kv-modal"><p class="kv-muted">Laden...</p></div>'; return; }

      var media = item.media || [];
      var plaats = [item.voornaam, item.regio].filter(Boolean).join(' uit ');
      /* Deeplink + deelteksten (opdracht 2, 13-07): elke inzending is deelbaar. */
      var deelUrl = location.origin + '/pages/klantvijvers?inzending=' + encodeURIComponent(item.id);
      var deelTekst = 'Bekijk mijn vijver bij Vijvercentrum';
      var deelWa = 'https://wa.me/?text=' + encodeURIComponent(deelTekst + ' ' + deelUrl);
      var deelFb = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(deelUrl);
      modal.innerHTML =
        '<div class="kv-modal kv-detail" role="dialog" aria-modal="true" aria-label="' + esc(item.titel) + '">' +
          '<button type="button" class="kv-modal-sluit" data-kv-sluit aria-label="Sluiten">&times;</button>' +
          '<div class="kv-carrousel" data-kv-carrousel>' +
            '<div class="kv-carrousel-track" data-kv-track>' +
              media.map(function (url, i) {
                return '<img class="kv-carrousel-foto" src="' + esc(url) + '" alt="' + esc(item.titel) + ', foto ' + (i + 1) + '" ' + (i ? 'loading="lazy"' : '') + '>';
              }).join('') +
            '</div>' +
            (media.length > 1 ?
              '<button type="button" class="kv-carrousel-knop kv-carrousel-vorige" data-kv-vorige aria-label="Vorige foto">&lsaquo;</button>' +
              '<button type="button" class="kv-carrousel-knop kv-carrousel-volgende" data-kv-volgende aria-label="Volgende foto">&rsaquo;</button>' +
              '<div class="kv-carrousel-dots" data-kv-dots>' + media.map(function (u, i) {
                return '<button type="button" class="kv-dot' + (i === 0 ? ' kv-dot-actief' : '') + '" data-kv-dot="' + i + '" aria-label="Foto ' + (i + 1) + '"></button>';
              }).join('') + '</div>' : '') +
          '</div>' +
          '<div class="kv-detail-body">' +
            '<h2 class="kv-detail-titel">' + esc(item.titel) + '</h2>' +
            (plaats ? '<p class="kv-kaart-plaats">' + esc(plaats) + (item.created_at ? ' &middot; ' + fmtDatum(item.created_at) : '') + '</p>' : '') +
            '<p class="kv-kaart-meta">' +
              typeBadge(item.inzending_type) +
              (item.vijvertype ? '<span class="kv-badge">' + esc(item.vijvertype) + '</span>' : '') +
              (item.volume_liter ? '<span class="kv-badge kv-badge-volume">' + fmtVolume(item.volume_liter) + '</span>' : '') +
            '</p>' +
            /* Zonder verhaal geen leeg blok (titel en verhaal zijn optioneel sinds 21-10-2026) */
            (String(item.verhaal || '').trim() ? '<div class="kv-detail-verhaal">' + esc(item.verhaal).replace(/\n/g, '<br>') + '</div>' : '') +
            (item.video_url ? '<p><a class="kv-knop-link" href="' + esc(item.video_url) + '" target="_blank" rel="noopener nofollow">Bekijk de video van deze vijver</a></p>' : '') +
            '<div class="kv-deel mt-4 mb-2 rounded-xl border border-slate-100 bg-slate-50 p-4" data-kv-deel>' +
              '<span class="kv-deel-kop">Deel deze vijver</span>' +
              '<div class="kv-deel-knoppen">' +
                '<a class="kv-deel-knop" data-kv-deel-wa href="' + esc(deelWa) + '" target="_blank" rel="noopener"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg> WhatsApp</a>' +
                '<a class="kv-deel-knop" data-kv-deel-fb href="' + esc(deelFb) + '" target="_blank" rel="noopener"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg> Facebook</a>' +
                '<button type="button" class="kv-deel-knop" data-kv-deel-kopieer data-kv-deel-url="' + esc(deelUrl) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg> Kopieer link</button>' +
              '</div>' +
            '</div>' +
            '<h3 class="kv-detail-kop">Gebruikte techniek</h3>' +
            '<div data-kv-gear></div>' +
            '<h3 class="kv-detail-kop">Reacties <span class="kv-muted" data-kv-reactieteller>(' + ((item.comments || []).length || item.comments_count || 0) + ')</span></h3>' +
            '<div class="kv-reacties" data-kv-reacties>' + renderReacties(item.comments || []) + '</div>' +
            '<form class="kv-reactie-form" data-kv-reactieform>' +
              '<label class="kv-label" for="kv-reactie-body">Laat een reactie achter</label>' +
              '<textarea class="kv-input" id="kv-reactie-body" rows="3" maxlength="600" placeholder="Mooie vijver! Welke pomp gebruik je?" required></textarea>' +
              '<input class="kv-input" type="text" data-kv-reactienaam maxlength="40" placeholder="Je voornaam (zichtbaar bij je reactie)" value="' + esc(CONFIG.CUSTOMER_FIRST_NAME || '') + '">' +
              '<button type="submit" class="kv-knop kv-knop-primair">Plaats reactie</button>' +
              '<p class="kv-muted kv-reactie-uitleg">' + 'Je reageert met je Vijvercentrum-account. Heb je bij ons besteld? Dan krijgt je reactie de badge Geverifieerde klant.' + '</p>' +
            '</form>' +
            '<div class="kv-detail-voet">' +
              '<div class="kv-flag" data-kv-flag>' +
                '<button type="button" class="kv-knop-link kv-flag-knop" data-kv-flag-open>Melden</button>' +
                '<span class="kv-flag-form" hidden>' +
                  '<select class="kv-input kv-flag-reden" data-kv-flag-reden>' +
                    '<option value="">Waarom meld je dit?</option>' +
                    '<option value="ongepast">Ongepaste inhoud</option>' +
                    '<option value="spam">Spam of reclame</option>' +
                    '<option value="dierenwelzijn">Zorgen over dierenwelzijn</option>' +
                    '<option value="anders">Iets anders</option>' +
                  '</select>' +
                  '<button type="button" class="kv-knop kv-knop-secundair" data-kv-flag-stuur>Verstuur melding</button>' +
                '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      bindModal(item);
      var sluitKnop = qs('[data-kv-sluit]', modal);
      if (sluitKnop) sluitKnop.focus();
    }

    function renderReacties(reacties) {
      if (!reacties.length) return '<p class="kv-muted">Nog geen reacties. Wees de eerste!</p>';
      return reacties.map(function (r) {
        return '<div class="kv-reactie">' +
          '<p class="kv-reactie-kop"><strong>' + esc(r.author_naam || 'Vijverliefhebber') + '</strong>' +
          (r.verified_customer ? ' <span class="kv-badge kv-badge-geverifieerd">Geverifieerde klant</span>' : '') +
          (r.created_at ? ' <span class="kv-muted">' + fmtDatum(r.created_at) + '</span>' : '') + '</p>' +
          '<p class="kv-reactie-body">' + esc(r.body) + '</p>' +
        '</div>';
      }).join('');
    }

    function bindModal(item) {
      /* carrousel: swipe en knoppen */
      var track = qs('[data-kv-track]', modal);
      var media = item.media || [];
      var index = 0;
      function gaNaar(i) {
        index = Math.max(0, Math.min(media.length - 1, i));
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        qsa('[data-kv-dot]', modal).forEach(function (d, di) { d.classList.toggle('kv-dot-actief', di === index); });
      }
      var vorige = qs('[data-kv-vorige]', modal), volgende = qs('[data-kv-volgende]', modal);
      if (vorige) vorige.addEventListener('click', function () { gaNaar(index - 1); });
      if (volgende) volgende.addEventListener('click', function () { gaNaar(index + 1); });
      qsa('[data-kv-dot]', modal).forEach(function (d) {
        d.addEventListener('click', function () { gaNaar(parseInt(d.dataset.kvDot, 10)); });
      });
      var startX = null;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) gaNaar(index + (delta < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });

      qs('[data-kv-sluit]', modal).addEventListener('click', sluitModal);

      /* gear-lijst laden */
      renderGearLijst(qs('[data-kv-gear]', modal), item.techniek || []);

      /* reactie-formulier */
      var form = qs('[data-kv-reactieform]', modal);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var body = qs('#kv-reactie-body', modal).value.trim();
        var naam = qs('[data-kv-reactienaam]', modal).value.trim();
        if (body.length < 2) { toast('Schrijf eerst een reactie.'); return; }
        var knop = qs('button[type="submit"]', form);
        vraagLogin('Log in om te reageren. Bestelde je eerder bij ons? Dan krijg je de badge Geverifieerde klant.', 'reactie').then(function () {
          knop.disabled = true; knop.textContent = 'Plaatsen...';
          return apiFetchAuth(endpoint('comment'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ submission_id: item.id, body: body, author_naam: naam })
          }).then(function (data) {
            qs('#kv-reactie-body', modal).value = '';
            meet('kv_reactie', { kv_inzending: item.id, kv_status: (data && data.status) || '' });
            if (data && data.status === 'live') {
              /* direct tonen */
              var lijst = qs('[data-kv-reacties]', modal);
              if (lijst.querySelector('.kv-muted')) lijst.innerHTML = '';
              lijst.insertAdjacentHTML('beforeend', renderReacties([{
                author_naam: naam || 'Jij', body: body,
                verified_customer: !!data.verified_customer, created_at: new Date().toISOString()
              }]));
              toast('Je reactie staat erop. Bedankt!');
            } else {
              toast('Bedankt! Je reactie wordt even bekeken en staat er meestal binnen 15 minuten op.');
            }
          });
        }).catch(function (err) {
          if (err.code !== 'geannuleerd') meet('kv_fout', { kv_bron: 'reactie', kv_reden: meetReden(err) });
          if (err.code !== 'geannuleerd') toast(err.kv ? err.message : 'Reageren mislukte.', 'fout');
        }).finally(function () { knop.disabled = false; knop.textContent = 'Plaats reactie'; });
      });

      /* flag-knop */
      var flagOpen = qs('[data-kv-flag-open]', modal);
      flagOpen.addEventListener('click', function () {
        qs('.kv-flag-form', modal).hidden = false;
        flagOpen.hidden = true;
      });
      qs('[data-kv-flag-stuur]', modal).addEventListener('click', function () {
        var reden = qs('[data-kv-flag-reden]', modal).value;
        if (!reden) { toast('Kies eerst een reden.'); return; }
        /* melden vereist login (tempo per klant), dus de
           geauthenticeerde variant via de App Proxy */
        apiFetchAuth(endpoint('report'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ submission_id: item.id, reden: reden })
        }).then(function () {
          qs('[data-kv-flag]', modal).innerHTML = '<span class="kv-muted">Bedankt voor je melding. We kijken ernaar.</span>';
        }).catch(function (err) { toast(err.kv ? err.message : 'Melden mislukte.', 'fout'); });
      });

      /* deel-knoppen (opdracht 2): WhatsApp/Facebook openen zelf via href,
         kopieer-link gebruikt de clipboard met fail-safe fallback. */
      var deelWaKnop = qs('[data-kv-deel-wa]', modal);
      if (deelWaKnop) deelWaKnop.addEventListener('click', function () { meet('kv_deel', { kv_kanaal: 'whatsapp', kv_inzending: item.id }); });
      var deelFbKnop = qs('[data-kv-deel-fb]', modal);
      if (deelFbKnop) deelFbKnop.addEventListener('click', function () { meet('kv_deel', { kv_kanaal: 'facebook', kv_inzending: item.id }); });
      var deelKopieer = qs('[data-kv-deel-kopieer]', modal);
      if (deelKopieer) {
        deelKopieer.addEventListener('click', function () {
          var url = deelKopieer.getAttribute('data-kv-deel-url') || '';
          function gelukt() { toast('Link gekopieerd. Plak hem waar je wilt.'); }
          function fallback() {
            try {
              var t = document.createElement('textarea');
              t.value = url; t.setAttribute('readonly', '');
              t.style.position = 'absolute'; t.style.left = '-9999px';
              document.body.appendChild(t); t.select();
              var ok = document.execCommand('copy');
              document.body.removeChild(t);
              if (ok) { gelukt(); } else { window.prompt('Kopieer de link naar je inzending:', url); }
            } catch (e) { window.prompt('Kopieer de link naar je inzending:', url); }
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(gelukt).catch(fallback);
          } else { fallback(); }
          meet('kv_deel', { kv_kanaal: 'kopieer', kv_inzending: item.id });
        });
      }
    }

    function sluitModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('kv-scroll-vast');
      if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus();
    }

    /* -------- Schema.org: ImageGallery met interactionStatistic -------- */
    function injectJsonLd(items, totaal) {
      var oud = qs('#kv-jsonld');
      if (oud) oud.remove();
      var data = {
        '@context': 'https://schema.org',
        '@type': 'ImageGallery',
        name: 'Klantvijvers van Vijvercentrum.nl',
        description: 'Echte vijvers van echte klanten, met foto’s, verhalen en gebruikte techniek.',
        url: location.origin + location.pathname,
        numberOfItems: totaal,
        associatedMedia: items.slice(0, 12).map(function (item) {
          return {
            '@type': 'ImageObject',
            name: item.titel,
            contentUrl: (item.media && item.media[0]) || undefined,
            interactionStatistic: [
              { '@type': 'InteractionCounter', interactionType: { '@type': 'LikeAction' }, userInteractionCount: item.votes_count || 0 },
              { '@type': 'InteractionCounter', interactionType: { '@type': 'CommentAction' }, userInteractionCount: item.comments_count || 0 }
            ]
          };
        })
      };
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'kv-jsonld';
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    }

    /* -------- events -------- */
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-kv-open]');
      if (open) { openDetail(open.dataset.kvOpen); return; }
      var stemKnop = e.target.closest('[data-kv-stem]');
      if (stemKnop) { stem(stemKnop.dataset.kvStem, stemKnop); return; }
      var typeChip = e.target.closest('[data-kv-type-chip]');
      if (typeChip) {
        qsa('[data-kv-type-chip]', root).forEach(function (c) {
          c.classList.toggle('kv-chip-actief', c === typeChip);
          c.setAttribute('aria-pressed', c === typeChip ? 'true' : 'false');
        });
        state.filters.type = typeChip.dataset.kvTypeChip || '';
        meet('kv_filter', { kv_filter: 'type', kv_waarde: state.filters.type || 'alle' });
        laad(true);
        return;
      }
      var chip = e.target.closest('[data-kv-chip]');
      if (chip) {
        chip.classList.toggle('kv-chip-actief');
        var waarde = chip.dataset.kvChip;
        var idx = state.filters.techniek.indexOf(waarde);
        if (idx === -1) state.filters.techniek.push(waarde); else state.filters.techniek.splice(idx, 1);
        meet('kv_filter', { kv_filter: 'techniek', kv_waarde: waarde });
        laad(true);
      }
    });

    var typeSelect = qs('[data-kv-filter-type]', root);
    if (typeSelect) typeSelect.addEventListener('change', function () { state.filters.vijvertype = this.value; meet('kv_filter', { kv_filter: 'vijvertype', kv_waarde: this.value || 'alle' }); laad(true); });
    var volumeSelect = qs('[data-kv-filter-volume]', root);
    if (volumeSelect) volumeSelect.addEventListener('change', function () { state.filters.volume = this.value; meet('kv_filter', { kv_filter: 'volume', kv_waarde: this.value || 'alle' }); laad(true); });
    var sortSelect = qs('[data-kv-filter-sort]', root);
    if (sortSelect) sortSelect.addEventListener('change', function () { state.filters.sort = this.value; meet('kv_filter', { kv_filter: 'sort', kv_waarde: this.value }); laad(true); });

    meerKnop.addEventListener('click', function () { laad(false); });

    /* infinite scroll: sentinel triggert de volgende pagina */
    if ('IntersectionObserver' in window && sentinel) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !state.bezig && !state.klaar && state.page > 1) laad(false);
      }, { rootMargin: '600px 0px' }).observe(sentinel);
    }

    meet('kv_galerij_view', { kv_bron: meetBron() });
    laad(true);
    /* Deeplink (opdracht 2, 13-07): ?inzending=<id> opent direct de detail-modal. */
    try {
      var kvOpenId = new URLSearchParams(location.search).get('inzending');
      if (kvOpenId) openDetail(kvOpenId, 'deeplink');
    } catch (e) { /* geen URLSearchParams-support: stil negeren */ }
    initMaandBlok(root);
    initJaarronde(root);
  }

  /* ================= VIJVER VAN DE MAAND (blok) =================
     Besluit Kees 13-07 (hybride 1a): hartjes bepalen de shortlist,
     de redactie kiest de winnaar. Dit blok licht de door de redactie
     gekozen maandwinnaar uit bovenaan de galerij. Fail-silent: geen
     winnaar of een API-fout = blok blijft verborgen, niets kapot.
     Geen prijsinformatie (bewust). */
  function initMaandBlok(root) {
    var blok = qs('[data-kv-maand]', root);
    if (!blok) return;
    apiFetch(endpoint('maandShortlist')).then(function (data) {
      var w = data && data.winnaar;
      if (!w) return; /* fail-silent: nog geen maandwinnaar */
      var foto = (w.media && w.media[0]) || '';
      var plaats = [w.voornaam, w.regio].filter(Boolean).join(' uit ');
      blok.innerHTML =
        '<div class="kv-maand-inner">' +
          (foto ? '<button type="button" class="kv-maand-fotoknop" data-kv-open="' + esc(w.id) + '" aria-label="Bekijk ' + esc(w.titel) + '">' +
            '<img class="kv-maand-foto" src="' + esc(foto) + '" alt="' + esc(w.titel) + '" loading="lazy"></button>' : '') +
          '<div class="kv-maand-tekst">' +
            '<span class="kv-badge kv-badge-featured">Vijver van de Maand</span>' +
            '<h2 class="kv-maand-titel">' + esc(w.titel) + '</h2>' +
            (plaats ? '<p class="kv-kaart-plaats">' + esc(plaats) + '</p>' : '') +
            '<p class="kv-muted kv-maand-uitleg">Jullie hartjes bepalen de shortlist, wij kozen hieruit de mooiste. Gefeliciteerd!</p>' +
            '<button type="button" class="kv-knop kv-knop-primair" data-kv-open="' + esc(w.id) + '">Bekijk deze vijver</button>' +
          '</div>' +
        '</div>';
      blok.hidden = false;
    }).catch(function () { /* fail-silent */ });
  }

  /* ================= VIJVER VAN HET JAAR (stemronde) =================
     Besluit Kees 13-07 (3a): maandwinnaars + publieke stemronde + jury
     (weging instelbaar). Dit blok verschijnt alleen als er een OPEN
     stemronde is; het toont de genomineerden met een stem-knop (1 stem
     per ingelogde klant), een teller en de looptijd. Fail-silent bij
     geen open ronde of een API-fout. Geen prijsinformatie (bewust). */
  function initJaarronde(root) {
    var blok = qs('[data-kv-jaarronde]', root);
    if (!blok) return;
    var gestemdKey = null;

    function looptijdTekst(ronde) {
      var eind = ronde.eind_at ? fmtDatum(ronde.eind_at) : '';
      return eind ? 'Stemmen kan nog tot en met ' + eind + '.' : 'De stemronde is nu open.';
    }

    function nomineeKaart(n, alGestemd) {
      var foto = (n.media && n.media[0]) || '';
      var plaats = [n.voornaam, n.regio].filter(Boolean).join(' uit ');
      return '<article class="kv-jaar-kaart" data-kv-jaarkaart="' + esc(n.id) + '">' +
        (foto ? '<button type="button" class="kv-jaar-fotoknop" data-kv-open="' + esc(n.id) + '" aria-label="Bekijk ' + esc(n.titel) + '">' +
          '<img class="kv-jaar-foto" src="' + esc(foto) + '" alt="' + esc(n.titel) + '" loading="lazy"></button>' : '') +
        '<div class="kv-jaar-body">' +
          '<h3 class="kv-jaar-titel"><button type="button" class="kv-kaart-titelknop" data-kv-open="' + esc(n.id) + '">' + esc(n.titel) + '</button></h3>' +
          (plaats ? '<p class="kv-kaart-plaats">' + esc(plaats) + '</p>' : '') +
          '<div class="kv-jaar-acties">' +
            '<button type="button" class="kv-knop kv-knop-primair kv-jaar-stemknop" data-kv-jaarstem="' + esc(n.id) + '"' + (alGestemd ? ' disabled' : '') + '>' +
              (alGestemd ? 'Je hebt gestemd' : 'Stem op deze vijver') + '</button>' +
            '<span class="kv-jaar-teller"><strong data-kv-jaarteller>' + (n.jaar_stemtal || 0) + '</strong> stemmen</span>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    function render(ronde, genomineerden) {
      gestemdKey = 'kv-jaar-gestemd-' + ronde.id;
      var alGestemd = !!opslag.get(gestemdKey);
      blok.innerHTML =
        '<div class="kv-jaarronde-inner">' +
          '<header class="kv-jaarronde-kop">' +
            '<span class="kv-badge kv-badge-jaar">Vijver van het Jaar ' + esc(ronde.jaar) + '</span>' +
            '<h2 class="kv-jaarronde-titel">Stem op de Vijver van het Jaar</h2>' +
            '<p class="kv-muted">' + esc(looptijdTekst(ronde)) + ' 1 stem per persoon. De jury telt ook mee.</p>' +
          '</header>' +
          '<div class="kv-jaarronde-grid">' +
            genomineerden.map(function (n) { return nomineeKaart(n, alGestemd); }).join('') +
          '</div>' +
        '</div>';
      blok.hidden = false;
    }

    function markeerGestemd() {
      qsa('[data-kv-jaarstem]', blok).forEach(function (b) {
        b.disabled = true;
        b.textContent = 'Je hebt gestemd';
      });
    }

    function stemJaar(submissionId, ronde, knop) {
      if (opslag.get(gestemdKey)) { toast('Je hebt in deze stemronde al gestemd.'); return; }
      vraagLogin('Log in om te stemmen op de Vijver van het Jaar. 1 stem per persoon.', 'jaarstem').then(function () {
        knop.disabled = true;
        return apiFetchAuth(endpoint('jaarStem'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ stemronde_id: ronde.id, submission_id: submissionId })
        }).then(function (data) {
          var kaart = knop.closest('[data-kv-jaarkaart]');
          var teller = kaart && qs('[data-kv-jaarteller]', kaart);
          if (teller && data && typeof data.jaar_stemtal === 'number') teller.textContent = data.jaar_stemtal;
          opslag.set(gestemdKey, true);
          markeerGestemd();
          meet('kv_stem', { kv_inzending: submissionId, kv_bron: 'jaarronde' });
          toast('Bedankt voor je stem op de Vijver van het Jaar!');
        }).catch(function (err) {
          if (err.code === 'dubbel') { opslag.set(gestemdKey, true); markeerGestemd(); toast('Je hebt in deze stemronde al gestemd.'); return; }
          knop.disabled = false;
          toast(err.kv ? err.message : 'Stemmen mislukte. Probeer het opnieuw.', 'fout');
        });
      }).catch(function (err) {
        if (err.code !== 'geannuleerd') toast(err.message, 'fout');
      });
    }

    apiFetch(endpoint('jaarStemronde')).then(function (data) {
      var ronde = data && data.stemronde;
      var genomineerden = (data && data.genomineerden) || [];
      if (!ronde || genomineerden.length === 0) return; /* fail-silent */
      render(ronde, genomineerden);
      blok.addEventListener('click', function (e) {
        var open = e.target.closest('[data-kv-open]');
        if (open) { document.dispatchEvent(new CustomEvent('kv-open-detail', { detail: open.dataset.kvOpen })); return; }
        var stemKnop = e.target.closest('[data-kv-jaarstem]');
        if (stemKnop && !stemKnop.disabled) { stemJaar(stemKnop.dataset.kvJaarstem, ronde, stemKnop); }
      });
    }).catch(function () { /* fail-silent */ });
  }

  /* ========================= INSTUREN ========================= */
  function initInsturen(root) {
    var stappen = {
      login: qs('[data-kv-stap="login"]', root),
      email: qs('[data-kv-stap="email"]', root),
      code: qs('[data-kv-stap="code"]', root),
      form: qs('[data-kv-stap="form"]', root),
      verhaal: qs('[data-kv-stap="verhaal"]', root),
      klaar: qs('[data-kv-stap="klaar"]', root)
    };
    var foutEl = qs('[data-kv-form-fout]', root);
    var email = '';
    var technieken = []; /* [{handle, title}] */
    var fotos = [];      /* [{file, url}] na resize */
    var gekozenType = ''; /* inzending_type: vijver, koi, design of tuin */
    var bewerkId = null; /* gevuld in bewerk-modus: id van de eigen inzending */
    var bestaand = [];   /* bewerk-modus: [{path, url}] bestaande foto's die blijven */

    meet('kv_insturen_view', { kv_bron: meetBron() });

    /* kv_insturen_start: eenmalig zodra de klant het eerste veld aanraakt */
    var startGemeten = false;
    function meetStart() {
      if (startGemeten) return;
      startGemeten = true;
      meet('kv_insturen_start');
    }
    root.addEventListener('input', meetStart);

    /* De inlogknop in de login-stap (na een auth-fout bij bewerken) */
    root.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-kv-login-knop]')) meetLoginGestart('insturen');
    });

    function zetStap(naam) {
      Object.keys(stappen).forEach(function (k) { if (stappen[k]) stappen[k].hidden = k !== naam; });
      zetFout('');
      werkNogNodigBij();
    }

    /* -------- verhaal later: het bedankscherm (besluit Kees 21-10-2026) --------
       Na een inzending zonder verhaal geeft de server een aanvullink terug
       (/apps/vp/klantvijvers/aanvullen?id=&token=, zonder login). Een zin erbij
       gaat daarheen; Overslaan gaat gewoon door naar klaar. */
    var AANVUL_PAD = /^\/apps\/vp\/klantvijvers\/aanvullen\?id=[0-9a-f-]{36}&token=[0-9a-f]{64}$/;
    var laterUrl = '';
    var laterVeld = qs('[data-kv-later-verhaal]', root);
    var laterFout = qs('[data-kv-later-fout]', root);
    var laterKnop = qs('[data-kv-later-opslaan]', root);
    function zetLaterFout(tekst) {
      if (!laterFout) return;
      laterFout.textContent = tekst || '';
      laterFout.hidden = !tekst;
    }
    function zetLaterRegel(aan) {
      var regel = qs('[data-kv-klaar-verhaal]', root);
      if (regel) regel.hidden = !aan;
    }
    function verhaalLaterStart(url) {
      if (!stappen.verhaal || !laterVeld || !laterKnop || !AANVUL_PAD.test(url)) return false;
      laterUrl = url;
      laterVeld.value = '';
      zetLaterFout('');
      zetLaterRegel(false);
      zetStap('verhaal');
      return true;
    }
    function verhaalLaterKlaar(toegevoegd) {
      zetLaterRegel(toegevoegd);
      zetStap('klaar');
      window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
    }
    root.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var start = e.target.closest('[data-kv-later-start]');
      if (start && laterVeld) {
        var zin = start.getAttribute('data-kv-later-start');
        var huidig = laterVeld.value.replace(/\s+$/, '');
        laterVeld.value = huidig ? huidig + '\n' + zin : zin;
        laterVeld.focus();
        try { laterVeld.setSelectionRange(laterVeld.value.length, laterVeld.value.length); } catch (err) { /* ouder type */ }
        meet('kv_verhaal_hulp', { kv_bron: 'bedankscherm' });
        return;
      }
      /* De meting van Overslaan staat in initVerhaalLater (een keer per klik). */
      if (e.target.closest('[data-kv-stap="verhaal"] [data-kv-verhaal-overslaan]')) verhaalLaterKlaar(false);
    });
    if (laterKnop) laterKnop.addEventListener('click', function () {
      var tekst = laterVeld ? laterVeld.value.trim() : '';
      if (!tekst) { zetLaterFout('Schrijf eerst een zin, of kies Overslaan.'); return; }
      laterKnop.disabled = true;
      laterKnop.textContent = 'Bezig...';
      apiFetch(laterUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ verhaal: tekst })
      }).then(function () {
        window.KlantvijversMeting.verhaalToegevoegd('bedankscherm');
        verhaalLaterKlaar(true);
      }).catch(function (err) {
        meet('kv_fout', { kv_bron: 'verhaal_later', kv_reden: meetReden(err) });
        zetLaterFout(err && err.kv ? err.message : 'Dat lukte niet. Probeer het zo opnieuw, of kies Overslaan.');
      }).finally(function () {
        laterKnop.disabled = false;
        laterKnop.textContent = 'Zet erbij';
      });
    });
    /* 22-10-2026: een melding over een veld staat bij dat veld, en de pagina
       scrolt naar het veld; een melding zonder veld staat boven de verstuurknop. Eerder stond hij alleen
       bovenaan het formulier en sprong de pagina daarheen, weg van het veld en de
       knop; op een telefoon zag een klant dan niet wat er ontbrak (21-10: twee
       keer versturen op een iPhone, beide keren tegengehouden, niets bij de server). */
    var foutKnopEl = qs('[data-kv-form-fout-knop]', root);
    var VELD_ANKER = {
      titel: '[data-kv-titel]', vijvertype: '.kv-vijvertype-kiezer', volume: '[data-kv-volume]',
      foto: '[data-kv-foto-drop]', video: '[data-kv-video]', toestemming: '[data-kv-consent]',
      email: '[data-kv-email-anoniem]'
    };
    /* Vloeiend scrollen, met een directe sprong als het veld na 700 ms nog niet in
       beeld is (oudere iOS-versies, of een browser die de animatie overslaat). */
    function naarBeeld(el) {
      try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); }
      setTimeout(function () {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > (window.innerHeight || document.documentElement.clientHeight)) el.scrollIntoView({ block: 'center' });
      }, 700);
    }
    function wisVeldMarkering() {
      qsa('.kv-veld-markeer', root).forEach(function (el) { el.classList.remove('kv-veld-markeer'); });
      qsa('[data-kv-veld-melding]', root).forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    }
    /* 23-10-2026: markeren en focussen zijn losse functies, zodat het formulier
       alle ontbrekende velden tegelijk kan aanwijzen (zetFouten) in plaats van
       een voor een. zetFout met een enkel veld werkt precies als voorheen. */
    function markeerVeld(anker, msg) {
      var uitklap = anker.closest ? anker.closest('details') : null;
      if (uitklap) uitklap.open = true;
      var blok = (anker.closest && (anker.closest('.kv-veld') || anker.closest('label'))) || anker;
      blok.classList.add('kv-veld-markeer');
      var melding = document.createElement('p');
      melding.className = 'kv-veld-fout';
      melding.setAttribute('role', 'alert');
      melding.setAttribute('data-kv-veld-melding', '');
      melding.textContent = msg;
      blok.appendChild(melding);
      return blok;
    }
    function focusVeld(veld, anker) {
      var doel = veld === 'vijvertype' ? qs('[data-kv-vijvertype-kies]', root)
        : (anker.matches && anker.matches('input, textarea, select') ? anker : null);
      if (doel && doel.focus) { try { doel.focus({ preventScroll: true }); } catch (e) { /* oudere browser */ } }
    }
    function wisAlgemeneFout() {
      if (foutEl) { foutEl.textContent = ''; foutEl.hidden = true; }
      if (foutKnopEl) { foutKnopEl.textContent = ''; foutKnopEl.hidden = true; }
    }
    function wisMarkeringVan(veld) {
      var anker = VELD_ANKER[veld] ? qs(VELD_ANKER[veld], root) : null;
      var blok = anker && anker.closest ? anker.closest('.kv-veld-markeer') : null;
      if (!blok) return;
      blok.classList.remove('kv-veld-markeer');
      var m = qs('[data-kv-veld-melding]', blok);
      if (m && m.parentNode) m.parentNode.removeChild(m);
    }
    function zetFout(msg, veld) {
      wisVeldMarkering();
      var anker = msg && veld && VELD_ANKER[veld] ? qs(VELD_ANKER[veld], root) : null;
      if (foutEl) { foutEl.textContent = anker ? '' : (msg || ''); foutEl.hidden = !msg || !!anker; }
      /* Bij een veld staat de melding alleen bij dat veld (de pagina scrolt erheen);
         boven de knop alleen meldingen zonder veld, anders staat hij er dubbel. */
      if (foutKnopEl) { foutKnopEl.textContent = anker ? '' : (msg || ''); foutKnopEl.hidden = !msg || !!anker; }
      if (!msg) return;
      if (anker) {
        naarBeeld(markeerVeld(anker, msg));
        focusVeld(veld, anker);
        return;
      }
      var zichtbaar = foutEl && !foutEl.hidden && foutEl.offsetParent ? foutEl : null;
      var knopZichtbaar = foutKnopEl && foutKnopEl.offsetParent ? foutKnopEl : null;
      naarBeeld(knopZichtbaar || zichtbaar || foutEl || foutKnopEl);
    }
    /* Meerdere velden tegelijk: elk ontbrekend veld krijgt zijn eigen melding,
       de pagina gaat naar het eerste (van boven naar beneden). */
    function zetFouten(lijst) {
      if (!lijst || !lijst.length) { zetFout(''); return; }
      if (lijst.length === 1) { zetFout(lijst[0].tekst, lijst[0].veld); return; }
      wisVeldMarkering();
      wisAlgemeneFout();
      var eerste = null;
      lijst.forEach(function (f) {
        var anker = VELD_ANKER[f.veld] ? qs(VELD_ANKER[f.veld], root) : null;
        if (!anker) return;
        var blok = markeerVeld(anker, f.tekst);
        if (!eerste) eerste = { blok: blok, anker: anker, veld: f.veld };
      });
      if (!eerste) { zetFout(lijst[0].tekst); return; }
      naarBeeld(eerste.blok);
      focusVeld(eerste.veld, eerste.anker);
    }
    /* Wie het gemarkeerde veld aanpast, ziet de melding verdwijnen. */
    function wisBijInvoer(e) {
      var blok = e.target && e.target.closest ? e.target.closest('.kv-veld-markeer') : null;
      if (!blok) return;
      blok.classList.remove('kv-veld-markeer');
      var m = qs('[data-kv-veld-melding]', blok);
      if (m && m.parentNode) m.parentNode.removeChild(m);
      if (foutKnopEl) { foutKnopEl.textContent = ''; foutKnopEl.hidden = true; }
    }
    root.addEventListener('input', wisBijInvoer, true);
    root.addEventListener('change', wisBijInvoer, true);

    function toonIngelogd(weergave) {
      var el = qs('[data-kv-ingelogd]', root);
      if (el) {
        el.hidden = false;
        qs('[data-kv-ingelogd-email]', root).textContent = weergave || email;
      }
    }

    {
      /* Ingelogd = formulier met
         vooringevulde voornaam; niet ingelogd = login-stap met knop
         naar de accountpagina (return_url brengt de klant terug). */
      var toonFormIngelogd = function () {
        var voornaamVeld = qs('[data-kv-voornaam]', root);
        if (voornaamVeld && !voornaamVeld.value && CONFIG.CUSTOMER_FIRST_NAME) {
          voornaamVeld.value = CONFIG.CUSTOMER_FIRST_NAME;
        }
        toonIngelogd(CONFIG.CUSTOMER_FIRST_NAME
          ? CONFIG.CUSTOMER_FIRST_NAME + ' (je Vijvercentrum-account)'
          : 'je Vijvercentrum-account');
        var andereKnop = qs('[data-kv-andere-email]', root);
        if (andereKnop) andereKnop.hidden = true; /* wisselen gaat via /account */
        var emailVeldIn = qs('[data-kv-email-veld]', root);
        if (emailVeldIn) emailVeldIn.hidden = true; /* e-mail is al bekend via het account */
        zetStap('form');
      };
      /* GUARD kv-formulier-nooit-achter-poort-20260726 ---------------------
         Het instuurformulier mag NOOIT achter een inlogpoort staan.
         Besluit Kees 17-07-2026 (commit a3249a5): anoniem insturen is
         toegestaan; het account koppelt achteraf via e-mail-match in
         klantvijvers-mijn. Die poort kwam op 22-07 (bdc3684, bewerkfunctie)
         en 23-07 (1af1931) als bijvangst terug, en toen viel het insturen
         stil: 0 inzendingen van 24-07 t/m 26-07 bij wel bezoekers.
         De backend ondersteunt anoniem volledig, inclusief het tegoed:
         klantvijvers-mijn zet reward_status van 'geen_koppeling' terug op
         null zodra de inzender later inlogt, zodat de reward-agent alsnog
         uitkeert. Inloggen is dus nooit nodig om in te sturen.
         Wie hier iets wijzigt: identiteit is een VELD in het formulier,
         nooit een STAP ervoor. Alleen bewerken/verwijderen mag login-gated
         zijn, want dat vraagt eigenaarschap. --------------------------- */
      var toonFormAnoniem = function () {
        var emailVeldEl = qs('[data-kv-email-veld]', root);
        if (emailVeldEl) emailVeldEl.hidden = false;
        var loginKnop = qs('[data-kv-login-knop]', root);
        if (loginKnop) loginKnop.href = loginUrlMetReturn(loginKnop.getAttribute('href'));
        zetStap('form');
      };
      if (CONFIG.CUSTOMER_LOGGED_IN) { toonFormIngelogd(); } else { toonFormAnoniem(); }
      /* Loginstatus kan wisselen (ander tabblad, verse check): UI volgt mee.
         Het formulier zelf wordt nooit leeggemaakt, dus de klant verliest niets. */
      document.addEventListener('kv-auth-changed', function (e) {
        if (e.detail && e.detail.logged_in) { toonFormIngelogd(); laadMijnAlsBeschikbaar(); }
        else { toonFormAnoniem(); }
      });
      /* Directe verse check: de pagina kan een verouderde loginstatus tonen */
      versAuth(true);
    }

    /* -------- vijvertype: aantikken (besluit Kees 21-10-2026), verplicht -------- */
    var vijvertypeVeld = qs('[data-kv-vijvertype]', root);
    var vijvertypeChips = qsa('[data-kv-vijvertype-kies]', root);
    function zetVijvertype(waarde) {
      if (vijvertypeVeld) vijvertypeVeld.value = waarde || '';
      vijvertypeChips.forEach(function (c) {
        var actief = !!waarde && c.dataset.kvVijvertypeKies === waarde;
        c.classList.toggle('kv-chip-actief', actief);
        c.setAttribute('aria-pressed', actief ? 'true' : 'false');
      });
      werkNogNodigBij();
    }
    vijvertypeChips.forEach(function (c) {
      c.addEventListener('click', function () {
        meetStart();
        zetVijvertype(c.dataset.kvVijvertypeKies);
        /* 23-10-2026: alleen de eigen markering weg, de andere blijven staan. */
        wisMarkeringVan('vijvertype');
        wisAlgemeneFout();
      });
    });

    /* -------- nog nodig (23-10-2026) --------
       Boven de verstuurknop staat altijd wat er nog ontbreekt om te kunnen
       versturen, en dat lijstje werkt live bij. Elk onderdeel is een knop die
       naar het veld springt. De verstuurknop zelf blijft altijd bruikbaar. */
    function nogNodig() {
      var lijst = [];
      if (!((fotos ? fotos.length : 0) + (bestaand ? bestaand.length : 0))) lijst.push('foto');
      var vt = qs('[data-kv-vijvertype]', root);
      if (!vt || !vt.value) lijst.push('vijvertype');
      var emVeld = qs('[data-kv-email-veld]', root);
      if (!CONFIG.CUSTOMER_LOGGED_IN && emVeld && !emVeld.hidden) {
        var em = qs('[data-kv-email-anoniem]', root);
        if (!em || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())) lijst.push('email');
      }
      var cs = qs('[data-kv-consent]', root);
      if (!cs || !cs.checked) lijst.push('toestemming');
      return lijst;
    }
    /* Volledig afgeschermd: deze functie draait ook al tijdens het opstarten
       (zetStap), en mag het formulier nooit breken. De stand wordt pas
       vastgelegd als het lijstje echt getekend is. */
    function werkNogNodigBij() {
      try {
        var el = qs('[data-kv-nog-nodig]', root);
        if (!el) return;
        var namen = { foto: 'een foto', vijvertype: 'soort vijver', email: 'je e-mailadres', toestemming: 'het vinkje voor toestemming' };
        var lijst = nogNodig();
        var stand = lijst.join(',') || 'klaar';
        if (el.getAttribute('data-kv-stand') === stand && !el.hidden) return;
        if (!lijst.length) {
          el.classList.add('kv-nog-nodig-klaar');
          el.textContent = 'Alles staat klaar. Je kunt je vijver versturen.';
        } else {
          el.classList.remove('kv-nog-nodig-klaar');
          var knoppen = lijst.map(function (veld) {
            return '<button type="button" class="kv-nog-nodig-item" data-kv-ga-naar="' + veld + '">' + namen[veld] + '</button>';
          });
          var tekst = knoppen.length === 1 ? knoppen[0]
            : knoppen.slice(0, -1).join(', ') + ' en ' + knoppen[knoppen.length - 1];
          el.innerHTML = '<span class="kv-nog-nodig-kop">Nog nodig om te versturen:</span> ' + tekst + '.';
        }
        el.hidden = false;
        el.setAttribute('data-kv-stand', stand);
      } catch (e) { /* stil: het lijstje is een hulp, nooit een drempel */ }
    }
    root.addEventListener('click', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('[data-kv-ga-naar]') : null;
      if (!item) return;
      var veld = item.getAttribute('data-kv-ga-naar');
      var anker = VELD_ANKER[veld] ? qs(VELD_ANKER[veld], root) : null;
      if (!anker) return;
      naarBeeld((anker.closest && anker.closest('.kv-veld')) || anker);
      focusVeld(veld, anker);
    });
    root.addEventListener('input', werkNogNodigBij);
    root.addEventListener('change', werkNogNodigBij);
    werkNogNodigBij();

    /* -------- typekeuze: 4 keuzekaartjes, verplicht eerste veld -------- */
    var typeKaarten = qsa('[data-kv-type-kies]', root);
    typeKaarten.forEach(function (kaart) {
      kaart.addEventListener('click', function () {
        meetStart();
        gekozenType = kaart.dataset.kvTypeKies;
        typeKaarten.forEach(function (k) {
          var actief = k === kaart;
          k.classList.toggle('kv-type-kaart-actief', actief);
          k.setAttribute('aria-pressed', actief ? 'true' : 'false');
        });
        wisAlgemeneFout();
      });
    });

    /* -------- verhaal-teller -------- */
    /* 16-10-2026: "0 / 2000" voelde als huiswerk. Tot het minimum van de
       server (20 tekens, klantvijvers-submit) tonen we hoeveel er nog nodig
       is; daarna pas het aantal. */
    var verhaal = qs('[data-kv-verhaal]', root);
    var teller = qs('[data-kv-verhaal-teller]', root);
    if (verhaal && teller) {
      var updateTeller = function () {
        var n = verhaal.value.trim().length;
        /* Geen minimum meer (besluit Kees 21-10-2026): alleen hoeveel ruimte er nog is. */
        teller.textContent = n === 0 ? '' : verhaal.value.length + ' / ' + CONFIG.VERHAAL_MAX;
      };
      verhaal.addEventListener('input', updateTeller);
      updateTeller();
    }

    /* Hulpvragen boven het verhaal: zetten een beginzin in het tekstvak */
    root.addEventListener('click', function (e) {
      var start = e.target.closest('[data-kv-verhaal-start]');
      if (!start || !verhaal) return;
      var zin = start.getAttribute('data-kv-verhaal-start');
      var huidig = verhaal.value.replace(/\s+$/, '');
      verhaal.value = huidig ? huidig + '\n' + zin : zin;
      verhaal.dispatchEvent(new Event('input'));
      verhaal.focus();
      try { verhaal.setSelectionRange(verhaal.value.length, verhaal.value.length); } catch (err) { /* ouder type */ }
      meet('kv_verhaal_hulp', { kv_waarde: start.textContent });
    });

    /* -------- techniek-picker via /search/suggest.json -------- */
    var zoekInput = qs('[data-kv-techniek-zoek]', root);
    var zoekResultaten = qs('[data-kv-techniek-resultaten]', root);
    var chipsEl = qs('[data-kv-techniek-chips]', root);

    function renderTechniekChips() {
      chipsEl.innerHTML = technieken.map(function (t, i) {
        return '<span class="kv-chip kv-chip-actief">' + esc(t.title) +
          ' <button type="button" class="kv-chip-verwijder" data-kv-techniek-weg="' + i + '" aria-label="Verwijder ' + esc(t.title) + '">&times;</button></span>';
      }).join('');
      renderEerderBesteld();
    }

    function voegTechniekToe(handle, titel) {
      if (!handle) return false;
      if (technieken.some(function (t) { return t.handle === handle; })) return false;
      if (technieken.length >= 12) { toast('Maximaal 12 producten in je gear-lijst.'); return false; }
      technieken.push({ handle: handle, title: titel || handle });
      renderTechniekChips();
      return true;
    }

    /* Eerder door jou besteld (16-10-2026): data-eiland uit de sectie, alleen
       voor een ingelogde klant met bestellingen. Een tik voegt het product toe. */
    var eerderData = [];
    try {
      var eerderEl = qs('[data-kv-eerder-besteld-data]');
      if (eerderEl) eerderData = JSON.parse(eerderEl.textContent || '[]') || [];
    } catch (err) { eerderData = []; }
    var eerderWrap = qs('[data-kv-eerder-besteld]', root);
    var eerderLijst = qs('[data-kv-eerder-lijst]', root);
    function renderEerderBesteld() {
      if (!eerderWrap || !eerderLijst || !eerderData.length) return;
      eerderWrap.hidden = false;
      eerderLijst.innerHTML = eerderData.map(function (p) {
        var gekozen = technieken.some(function (t) { return t.handle === p.handle; });
        return '<button type="button" class="kv-eerder-knop' + (gekozen ? ' kv-eerder-gekozen' : '') + '" data-kv-eerder-kies="' + esc(p.handle) + '" data-kv-eerder-titel="' + esc(p.title) + '"' + (gekozen ? ' disabled aria-disabled="true"' : '') + '>' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" width="36" height="36" loading="lazy">' : '') +
          '<span>' + esc(p.title) + '</span>' +
          '<span class="kv-eerder-actie" aria-hidden="true">' + (gekozen ? 'Toegevoegd' : '+ Voeg toe') + '</span></button>';
      }).join('');
    }
    if (eerderLijst) {
      eerderLijst.addEventListener('click', function (e) {
        var k = e.target.closest('[data-kv-eerder-kies]');
        if (!k || k.disabled) return;
        if (voegTechniekToe(k.getAttribute('data-kv-eerder-kies'), k.getAttribute('data-kv-eerder-titel'))) {
          meet('kv_techniek_eerder_besteld');
        }
      });
    }

    chipsEl.addEventListener('click', function (e) {
      var weg = e.target.closest('[data-kv-techniek-weg]');
      if (weg) { technieken.splice(parseInt(weg.dataset.kvTechniekWeg, 10), 1); renderTechniekChips(); }
    });

    zoekInput.addEventListener('input', debounce(function () {
      var q = zoekInput.value.trim();
      if (q.length < 2) { zoekResultaten.hidden = true; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var producten = (((data || {}).resources || {}).results || {}).products || [];
          if (!producten.length) { zoekResultaten.innerHTML = '<p class="kv-muted">Niets gevonden. Probeer een merk of productnaam.</p>'; zoekResultaten.hidden = false; return; }
          zoekResultaten.innerHTML = producten.map(function (p) {
            var handle = p.handle || (p.url || '').split('/products/')[1] || '';
            handle = handle.split('?')[0];
            return '<button type="button" class="kv-techniek-suggestie" data-kv-techniek-kies="' + esc(handle) + '" data-kv-techniek-titel="' + esc(p.title) + '">' +
              (p.image ? '<img src="' + esc(p.image) + '" alt="" width="36" height="36" loading="lazy">' : '') +
              '<span>' + esc(p.title) + '</span></button>';
          }).join('');
          zoekResultaten.hidden = false;
        }).catch(function () { zoekResultaten.hidden = true; });
    }, 300));

    zoekResultaten.addEventListener('click', function (e) {
      var kies = e.target.closest('[data-kv-techniek-kies]');
      if (!kies) return;
      voegTechniekToe(kies.dataset.kvTechniekKies, kies.dataset.kvTechniekTitel);
      zoekInput.value = '';
      zoekResultaten.hidden = true;
    });

    /* Snelkeuzes boven de zoekbalk: vullen de zoekterm in en zoeken direct */
    root.addEventListener('click', function (e) {
      var snel = e.target.closest('[data-kv-techniek-snel]');
      if (!snel) return;
      zoekInput.value = snel.getAttribute('data-kv-techniek-snel');
      zoekInput.dispatchEvent(new Event('input'));
      zoekInput.focus();
      meet('kv_techniek_snelkeuze', { kv_waarde: snel.getAttribute('data-kv-techniek-snel') });
    });
    renderEerderBesteld();

    /* -------- foto-upload met client-side resize -------- */
    var fotoInput = qs('[data-kv-foto-input]', root);
    var fotoDrop = qs('[data-kv-foto-drop]', root);
    if (fotoDrop) {
      ['dragenter', 'dragover'].forEach(function (t) { fotoDrop.addEventListener(t, function () { fotoDrop.classList.add('kv-foto-drop-actief'); }); });
      ['dragleave', 'drop'].forEach(function (t) { fotoDrop.addEventListener(t, function () { fotoDrop.classList.remove('kv-foto-drop-actief'); }); });
    }
    var fotoPreview = qs('[data-kv-foto-preview]', root);
    var fotoStatus = qs('[data-kv-foto-status]', root);

    function renderFotos() {
      fotoPreview.innerHTML = fotos.map(function (f, i) {
        return '<span class="kv-foto-thumb"><img src="' + f.url + '" alt="Foto ' + (i + 1) + '">' +
          '<button type="button" class="kv-foto-weg" data-kv-foto-weg="' + i + '" aria-label="Verwijder foto ' + (i + 1) + '">&times;</button></span>';
      }).join('');
      fotoStatus.textContent = (bestaand.length + fotos.length) + ' van ' + CONFIG.MAX_FOTOS + ' foto’s';
      werkNogNodigBij();
    }

    fotoPreview.addEventListener('click', function (e) {
      var weg = e.target.closest('[data-kv-foto-weg]');
      if (weg) {
        var i = parseInt(weg.dataset.kvFotoWeg, 10);
        URL.revokeObjectURL(fotos[i].url);
        fotos.splice(i, 1);
        renderFotos();
      }
    });

    fotoInput.addEventListener('change', function () {
      var bestanden = Array.prototype.slice.call(fotoInput.files || []);
      fotoInput.value = ''; /* zelfde bestand opnieuw kiezen blijft mogelijk */
      var ruimte = CONFIG.MAX_FOTOS - fotos.length - bestaand.length;
      if (bestanden.length > ruimte) {
        toast('Maximaal ' + CONFIG.MAX_FOTOS + ' foto’s. De eerste ' + ruimte + ' zijn toegevoegd.');
        bestanden = bestanden.slice(0, ruimte);
      }
      var verwerkt = [];
      bestanden.forEach(function (bestand) {
        if (!/^image\//.test(bestand.type)) { meet('kv_fout', { kv_bron: 'foto', kv_reden: 'geen_afbeelding' }); toast(bestand.name + ' is geen afbeelding.'); return; }
        if (bestand.size > 25 * 1024 * 1024) { meet('kv_fout', { kv_bron: 'foto', kv_reden: 'te_groot' }); toast(bestand.name + ' is te groot (max 25 MB).'); return; }
        fotoStatus.textContent = 'Foto verwerken...';
        verwerkt.push(verkleinFoto(bestand).then(function (klein) {
          fotos.push({ file: klein, url: URL.createObjectURL(klein) });
          renderFotos();
          return true;
        }).catch(function (err) {
          meet('kv_fout', { kv_bron: 'foto', kv_reden: 'verwerken' });
          toast(err.kv ? err.message : 'Deze foto kon niet verwerkt worden.', 'fout');
          renderFotos();
          return false;
        }));
      });
      /* Meetplan: een kv_foto_toegevoegd per keuze, pas als de foto's echt
         verwerkt zijn. kv_aantal is het aantal foto's dat nu klaarstaat. */
      if (verwerkt.length) Promise.all(verwerkt).then(function (uit) {
        if (uit.filter(Boolean).length) meet('kv_foto_toegevoegd', { kv_aantal: bestaand.length + fotos.length });
      });
    });

    /* -------- bewerken en Jouw inzendingen (22-07-2026) --------
       Backend bestond al (klantvijvers-mijn, klantvijvers-verwijder en
       bewerk_id in klantvijvers-submit); dit is de klant-UX erbij.
       Bewerken prefillt het formulier, bestaande foto's blijven staan
       tenzij weggeklikt, en versturen gaat met bewerk_id plus
       media_behouden. Na een aanpassing gaat de inzending opnieuw
       langs de moderatie (even niet zichtbaar in de galerij). */
    var bestaandWrap = qs('[data-kv-bestaand-wrap]', root);
    var bestaandPreview = qs('[data-kv-bestaand-preview]', root);
    var bewerkBanner = qs('[data-kv-bewerk-banner]', root);
    var mijnWrap = qs('[data-kv-mijn]', root);
    var mijnLijst = qs('[data-kv-mijn-lijst]', root);
    var verstuurKnop = qs('[data-kv-verstuur]', root);

    function verstuurTekst() {
      if (bewerkId) return 'Sla mijn aanpassing op';
      return (verstuurKnop && verstuurKnop.getAttribute('data-kv-verstuur-tekst')) || 'Verstuur mijn vijver';
    }

    function renderBestaand() {
      if (!bestaandPreview) return;
      bestaandPreview.innerHTML = bestaand.map(function (b, i) {
        return '<span class="kv-foto-thumb"><img src="' + esc(b.url) + '" alt="Bestaande foto ' + (i + 1) + '">' +
          '<button type="button" class="kv-foto-weg" data-kv-bestaand-weg="' + i + '" aria-label="Verwijder bestaande foto ' + (i + 1) + '">&times;</button></span>';
      }).join('');
      if (bestaandWrap) bestaandWrap.hidden = bestaand.length === 0;
      renderFotos();
    }
    if (bestaandPreview) bestaandPreview.addEventListener('click', function (e) {
      var weg = e.target.closest('[data-kv-bestaand-weg]');
      if (weg) { bestaand.splice(parseInt(weg.dataset.kvBestaandWeg, 10), 1); renderBestaand(); }
    });

    var STATUS_LABELS = {
      review: ['Wordt beoordeeld', 'kv-status-review'],
      live: ['Online in de galerij', 'kv-status-live'],
      afgewezen: ['Aanpassen gevraagd', 'kv-status-afgewezen']
    };

    function renderMijn(items) {
      if (!mijnWrap || !mijnLijst) return;
      if (!items.length) { mijnWrap.hidden = true; return; }
      mijnLijst.innerHTML = items.map(function (item) {
        var st = STATUS_LABELS[item.status] || [item.status, ''];
        var thumb = (item.media && item.media[0]) || '';
        var redenen = (item.status === 'afgewezen' && item.redenen && item.redenen.length)
          ? '<p class="kv-mijn-redenen">' + esc(item.redenen.join(' ')) + '</p>' : '';
        var wachtNaWijziging = (item.status === 'review' && item.wijzigingen && item.wijzigingen.length)
          ? '<p class="kv-mijn-redenen">Je aanpassing wordt beoordeeld; daarna staat de nieuwe versie online.</p>' : '';
        return '<div class="kv-mijn-item">' +
          (thumb ? '<img src="' + esc(thumb) + '" alt="" loading="lazy">' : '') +
          '<div class="kv-mijn-info">' +
          '<strong class="kv-mijn-titel">' + esc(item.titel || 'Je inzending') + '</strong>' +
          '<span class="kv-badge ' + st[1] + '">' + esc(st[0]) + '</span>' +
          redenen + wachtNaWijziging +
          '<div class="kv-mijn-knoppen">' +
          '<button type="button" class="kv-knop kv-knop-secundair kv-knop-klein" data-kv-mijn-bewerk="' + esc(item.id) + '">' +
          (item.status === 'afgewezen' ? 'Pas aan en stuur opnieuw in' : 'Bewerken') + '</button>' +
          (item.status === 'live' ? '<a class="kv-knop kv-knop-secundair kv-knop-klein" href="/pages/klantvijvers?inzending=' + esc(item.id) + '">Bekijken</a>' : '') +
          '<button type="button" class="kv-knop-link" data-kv-mijn-weg="' + esc(item.id) + '">Verwijderen</button>' +
          '</div></div></div>';
      }).join('');
      mijnWrap.hidden = false;
    }

    var mijnItems = [];
    function laadMijn() {
      if (!CONFIG.CUSTOMER_LOGGED_IN || !mijnWrap) return;
      apiFetchAuth(endpoint('mijn')).then(function (data) {
        mijnItems = (data && data.items) || [];
        renderMijn(mijnItems);
      }).catch(function () { /* fail-silent: blok blijft verborgen */ });
    }

    function stopBewerken() {
      bewerkId = null;
      bestaand = [];
      renderBestaand();
      fotos.forEach(function (f) { URL.revokeObjectURL(f.url); });
      fotos = [];
      renderFotos();
      technieken = [];
      renderTechniekChips();
      gekozenType = '';
      typeKaarten.forEach(function (k) { k.classList.remove('kv-type-kaart-actief'); k.setAttribute('aria-pressed', 'false'); });
      var f = qs('[data-kv-form]', root);
      if (f) f.reset();
      var voornaamVeld2 = qs('[data-kv-voornaam]', root);
      if (voornaamVeld2 && CONFIG.CUSTOMER_FIRST_NAME) voornaamVeld2.value = CONFIG.CUSTOMER_FIRST_NAME;
      if (verhaal) verhaal.dispatchEvent(new Event('input'));
      if (bewerkBanner) bewerkBanner.hidden = true;
      if (verstuurKnop) verstuurKnop.textContent = verstuurTekst();
      zetFout('');
    }
    var bewerkStop = qs('[data-kv-bewerk-stop]', root);
    if (bewerkStop) bewerkStop.addEventListener('click', stopBewerken);

    function startBewerken(item) {
      stopBewerken();
      bewerkId = item.id;
      meet('kv_bewerk_start', { kv_type: item.inzending_type });
      /* typekeuze */
      gekozenType = item.inzending_type || '';
      typeKaarten.forEach(function (k) {
        var actief = k.dataset.kvTypeKies === gekozenType;
        k.classList.toggle('kv-type-kaart-actief', actief);
        k.setAttribute('aria-pressed', actief ? 'true' : 'false');
      });
      /* velden */
      qs('[data-kv-titel]', root).value = item.titel || '';
      verhaal.value = item.verhaal || '';
      verhaal.dispatchEvent(new Event('input'));
      zetVijvertype(item.vijvertype || '');
      qs('[data-kv-volume]', root).value = item.volume_liter || '';
      qs('[data-kv-video]', root).value = item.video_url || '';
      var videoUitklap = qs('[data-kv-video-uitklap]', root);
      if (videoUitklap && item.video_url) videoUitklap.open = true;
      if (item.voornaam) qs('[data-kv-voornaam]', root).value = item.voornaam;
      qs('[data-kv-regio]', root).value = item.regio || '';
      /* techniek: handles direct als chip, titels laden na */
      technieken = (item.techniek || []).map(function (h) { return { handle: h, title: h }; });
      renderTechniekChips();
      technieken.forEach(function (t) {
        fetch('/products/' + encodeURIComponent(t.handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { if (p && p.title) { t.title = p.title; renderTechniekChips(); } })
          .catch(function () { /* handle blijft als label staan */ });
      });
      /* bestaande foto's */
      bestaand = (item.media_paths || []).map(function (pad, i) {
        return { path: pad, url: (item.media && item.media[i]) || '' };
      });
      renderBestaand();
      /* consent blijft gelden voor de eigen inzending */
      var consentBox = qs('[data-kv-consent]', root);
      if (consentBox) consentBox.checked = true;
      if (bewerkBanner) {
        bewerkBanner.hidden = false;
        var titelEl = qs('[data-kv-bewerk-titel]', root);
        if (titelEl) titelEl.textContent = '"' + (item.titel || 'je inzending') + '"';
      }
      if (verstuurKnop) verstuurKnop.textContent = verstuurTekst();
      zetStap('form');
      var kaart = document.getElementById('insturen-form');
      if (kaart) kaart.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (mijnLijst) mijnLijst.addEventListener('click', function (e) {
      var bewerk = e.target.closest('[data-kv-mijn-bewerk]');
      if (bewerk) {
        var item = mijnItems.filter(function (i) { return i.id === bewerk.dataset.kvMijnBewerk; })[0];
        if (item) startBewerken(item);
        return;
      }
      var weg = e.target.closest('[data-kv-mijn-weg]');
      if (weg && window.confirm('Weet je zeker dat je deze inzending wilt verwijderen? Dit haalt hem ook uit de galerij.')) {
        weg.disabled = true;
        apiFetchAuth(endpoint('verwijder'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: weg.dataset.kvMijnWeg })
        }).then(function () {
          toast('Je inzending is verwijderd.');
          if (bewerkId === weg.dataset.kvMijnWeg) stopBewerken();
          laadMijn();
        }).catch(function (err) {
          weg.disabled = false;
          toast(err.kv ? err.message : 'Verwijderen mislukte. Probeer het opnieuw.', 'fout');
        });
      }
    });

    laadMijn();
    function laadMijnAlsBeschikbaar() { try { laadMijn(); } catch (e) { /* stil */ } }

    /* -------- versturen -------- */
    qs('[data-kv-form]', root).addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.target;
      /* Meetplan: elke klik op Verstuur is een poging; een weigering in het
         formulier zelf is kv_verstuur_fout met reden validatie_<veld>. */
      var pogingBewerkt = bewerkId ? 'ja' : 'nee';
      meet('kv_verstuur_poging', { kv_type: gekozenType || 'vijver', kv_aantal: fotos.length + bestaand.length, kv_bewerkt: pogingBewerkt });
      /* 23-10-2026: alle ontbrekende velden tegelijk aanwijzen. Eerder stopte de
         controle bij de eerste fout, zodat een klant de verplichte velden een voor
         een ontdekte en steeds opnieuw moest versturen. */
      var fouten = [];
      function weiger(veld, tekst) { fouten.push({ veld: veld, tekst: tekst }); }
      var titel = qs('[data-kv-titel]', root).value.trim();
      var verhaalTekst = verhaal.value.trim();
      var vijvertype = qs('[data-kv-vijvertype]', root).value;
      /* type=text (03-10-2026): 12.000 liter = 12000, komma wordt punt. */
      var volume = String(qs('[data-kv-volume]', root).value || '').replace(/[\s.]/g, '').replace(',', '.');
      var videoUrl = qs('[data-kv-video]', root).value.trim();
      var voornaam = qs('[data-kv-voornaam]', root).value.trim();
      var regio = qs('[data-kv-regio]', root).value.trim();
      var consent = qs('[data-kv-consent]', root).checked;

      /* Servercontract klantvijvers-submit: inzending_type is optioneel en
         valt terug op 'vijver'. Niet blokkeren op een keuze die de server
         zelf al afhandelt (besluit Kees 17-07: client matcht de server). */
      if (!gekozenType) gekozenType = 'vijver';
      /* Besluit Kees 21-10-2026: titel en verhaal zijn optioneel. Een lege titel
         wordt op de server "<vijvertype> van <voornaam>"; een verhaal kan ook
         later (het bedankscherm of de aanvullink in de mail). */
      if (!fotos.length && !bestaand.length) weiger('foto', 'Voeg minimaal 1 foto toe. Je vijver verdient het!');
      if (!vijvertype) weiger('vijvertype', 'Tik aan wat voor vijver het is.');
      if (titel && titel.length < 3) weiger('titel', 'Een titel heeft minimaal 3 tekens, of laat hem leeg.');
      /* Volume is server-side optioneel (volume_liter mag null). Alleen
         controleren als de klant iets heeft ingevuld: rekenwerk is de
         zwaarste drempel op dit formulier en nooit een reden om te blokkeren. */
      if (volume && !(Number(volume) > 0)) weiger('volume', 'Vul een geldig volume in liters in, of laat het veld leeg.');
      if (videoUrl && !/^https?:\/\//.test(videoUrl)) weiger('video', 'De video-link moet met https:// beginnen.');

      /* Anoniem (niet ingelogd): e-mailadres verplicht,
         zodat we kunnen mailen zodra de vijver online staat en de inzending
         later aan het account koppelen (waarmee ook het tegoed alsnog wordt
         uitgekeerd, zie klantvijvers-mijn). */
      var anoniem = !CONFIG.CUSTOMER_LOGGED_IN;
      var emailAnoniem = '';
      if (anoniem) {
        var emAnEl = qs('[data-kv-email-anoniem]', root);
        emailAnoniem = emAnEl ? emAnEl.value.trim() : '';
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailAnoniem)) weiger('email', 'Vul je e-mailadres in, dan laten we je weten zodra je vijver online staat.');
      }

      if (!consent) weiger('toestemming', 'Vink de toestemming aan, anders mogen we je vijver niet tonen.');
      if (fouten.length) {
        /* Meetplan ongewijzigd: een kv_verstuur_fout per poging, met als reden het eerste veld. */
        meet('kv_verstuur_fout', { kv_reden: 'validatie_' + fouten[0].veld, kv_bewerkt: pogingBewerkt });
        zetFouten(fouten);
        werkNogNodigBij();
        return;
      }

      var fd = new FormData();
      fd.append('titel', titel);
      fd.append('verhaal', verhaalTekst);
      fd.append('vijvertype', vijvertype);
      fd.append('inzending_type', gekozenType);
      if (volume) fd.append('volume_liter', volume);
      fd.append('techniek', JSON.stringify(technieken.map(function (t) { return t.handle; })));
      if (videoUrl) fd.append('video_url', videoUrl);
      if (voornaam) fd.append('voornaam', voornaam);
      if (regio) fd.append('regio', regio);
      fd.append('consent_versie', CONFIG.CONSENT_VERSIE);
      if (emailAnoniem) fd.append('email', emailAnoniem);
      if (bewerkId) {
        /* Bewerken: id mee plus de bestaande foto's die blijven staan */
        fd.append('bewerk_id', bewerkId);
        fd.append('media_behouden', JSON.stringify(bestaand.map(function (b) { return b.path; })));
      }
      fotos.forEach(function (f) { fd.append('fotos', f.file, f.file.name); });

      var knop = qs('[data-kv-verstuur]', root);
      var wasBewerk = !!bewerkId;
      knop.disabled = true; knop.textContent = wasBewerk ? 'Opslaan...' : 'Versturen...';
      zetFout('');

      /* Geen Content-Type zetten: de browser bepaalt de multipart-boundary */
      var verstuurCall = anoniem ? apiFetch : apiFetchAuth;
      verstuurCall(endpoint('submit'), { method: 'POST', body: fd, metStatus: true }).then(function (antwoord) {
        /* Meetplan: kv_insturen_klaar alleen bij een 201 van de server (een
           nieuwe inzending staat in de wachtrij); een opgeslagen bewerking (200)
           is kv_bewerking_opgeslagen. Elk ander 2xx-antwoord telt niet als
           ingestuurd: kv_verstuur_fout met reden onverwacht_<status>. */
        var status = antwoord && antwoord.status;
        if (wasBewerk && status === 200) {
          meet('kv_bewerking_opgeslagen', { kv_type: gekozenType });
        } else if (!wasBewerk && status === 201) {
          meet('kv_insturen_klaar', { kv_type: gekozenType, kv_aantal: fotos.length + bestaand.length, kv_status: (antwoord.data && antwoord.data.status) || '' });
        } else {
          meet('kv_verstuur_fout', { kv_reden: 'onverwacht_' + (status || 'onbekend'), kv_bewerkt: wasBewerk ? 'ja' : 'nee' });
        }
        var naamEl = qs('[data-kv-klaar-naam]', root);
        if (naamEl) naamEl.textContent = voornaam ? voornaam + ', bedankt' : 'Bedankt';
        var uitlegEl = qs('[data-kv-klaar-uitleg]', root);
        if (wasBewerk && uitlegEl) {
          uitlegEl.textContent = 'Je aanpassing is opgeslagen. Kees of Phoebe kijkt er nog even naar; tot die tijd zie je in de galerij heel even de oude of geen versie. Na goedkeuring (meestal binnen 1 dag) staat je nieuwe versie online.';
        }
        if (wasBewerk) { stopBewerken(); laadMijn(); }
        /* Zonder verhaal: eerst de vraag of er nog een zin bij mag (21-10-2026),
           met de aanvullink uit het antwoord van de server. */
        var aanvulUrl = !wasBewerk && antwoord && antwoord.data && typeof antwoord.data.aanvul_url === 'string' ? antwoord.data.aanvul_url : '';
        if (!verhaalTekst && aanvulUrl && verhaalLaterStart(aanvulUrl)) {
          meet('kv_bedank_getoond', { kv_bron: 'insturen', kv_status: 'verhaal_vraag' });
        } else {
          zetLaterRegel(false);
          zetStap('klaar');
          if (!wasBewerk) meet('kv_bedank_getoond', { kv_bron: 'insturen' });
        }
        window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      }).catch(function (err) {
        meet('kv_verstuur_fout', { kv_reden: meetReden(err), kv_bewerkt: wasBewerk ? 'ja' : 'nee' });
        /* Anoniem kan geen auth-fout hebben; nooit naar de inlogstap springen
           (dat verbergt een volledig ingevuld formulier, zie guard hierboven). */
        if (err.code === 'auth' && !anoniem) { zetStap('login'); }
        zetFout(err.kv ? err.message : (wasBewerk ? 'Opslaan mislukte. Probeer het opnieuw of app ons via WhatsApp.' : 'Versturen mislukte. Probeer het opnieuw of app ons via WhatsApp.'));
      }).finally(function () { knop.disabled = false; knop.textContent = verstuurTekst(); });
    });
  }

  /* ============================================================
     Preview-strip op de insturen-pagina (13-07-2026): toont de
     nieuwste inzendingen als kleine thumbnails die naar de galerij
     linken. Fail-silent: bij een lege galerij of een fout blijft
     de strip verborgen (leeg bij lancering). Geen prijsinformatie.
     ============================================================ */
  function initInsturenPreview(root) {
    var wrap = qs('[data-kv-preview]', root);
    if (!wrap) return;
    var strip = qs('[data-kv-preview-strip]', wrap);
    if (!strip) return;
    var galerijUrl = wrap.getAttribute('data-kv-galerij-url') || '/pages/klantvijvers#galerij';
    apiFetch(endpoint('gallery') + '?sort=nieuw&per_page=4').then(function (data) {
      var items = (data && data.items) || [];
      if (!items.length) return; /* fail-silent: niets tonen bij lege galerij */
      var html = items.slice(0, 4).map(function (item) {
        var foto = (item.media && item.media[0]) || '';
        if (!foto) return '';
        var titel = item.titel || 'Bekijk deze inzending';
        return '<a class="kv-preview-item" href="' + esc(galerijUrl) +
          '" aria-label="' + esc(titel) + '">' +
          '<img src="' + esc(foto) + '" alt="' + esc(titel) + '" loading="lazy"></a>';
      }).join('');
      if (!html) return;
      strip.innerHTML = html;
      wrap.hidden = false;
    }).catch(function () { /* fail-silent: strip blijft verborgen */ });
  }

  /* ================= VERHAAL LATER (meetplan 21-10-2026) =================
     De volgende stap van de klantreis (insturen met alleen foto's, op het
     bedankscherm "vertel er een zin bij" met Overslaan, en een aanvulpagina
     vanuit de mail) bestaat nog niet. De meetpunten staan klaar en doen
     niets zolang de elementen er niet zijn:
     - [data-kv-aanvul] op de pagina: kv_aanvul_geopend, kv_bron uit ?bron=
       (standaard 'direct');
     - klik op [data-kv-verhaal-overslaan="bedankscherm|mail"]:
       kv_verhaal_overgeslagen;
     - kv_verhaal_toegevoegd alleen na een geslaagd antwoord van de server:
       roep KlantvijversMeting.verhaalToegevoegd('bedankscherm' of 'mail') aan
       in de .then van die call, nooit bij de klik.
     kv_bedank_getoond vuurt al zodra het bedankscherm na een 201 verschijnt. */
  function initVerhaalLater() {
    document.addEventListener('click', function (e) {
      var knop = e.target && e.target.closest ? e.target.closest('[data-kv-verhaal-overslaan]') : null;
      if (knop) window.KlantvijversMeting.verhaalOvergeslagen(knop.getAttribute('data-kv-verhaal-overslaan') || 'bedankscherm');
    });
    if (qs('[data-kv-aanvul]')) window.KlantvijversMeting.aanvulGeopend();
  }

  /* ================= AANVULLEN: de link uit de mail (21-10-2026) =================
     /pages/klantvijvers-aanvullen?id=<uuid>&token=<hex>: zonder login een titel
     of verhaal bij een eigen inzending zetten. De route (via de App Proxy) is
     /apps/vp/klantvijvers/aanvullen met dezelfde parameters; een aanvulling op
     een live inzending wacht op de tekstmoderatie, de foto's blijven live. */
  function initAanvullen(root) {
    function stap(naam) {
      qsa('[data-kv-aanvul-stap]', root).forEach(function (el) { el.hidden = el.getAttribute('data-kv-aanvul-stap') !== naam; });
    }
    function fout(tekst) {
      var el = qs('[data-kv-aanvul-fouttekst]', root);
      if (el) el.textContent = tekst;
      stap('fout');
    }
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var id = String((params && params.get('id')) || '').toLowerCase();
    var token = String((params && params.get('token')) || '').toLowerCase();
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(id) || !/^[0-9a-f]{64}$/.test(token)) {
      fout('Deze link klopt niet. Gebruik de knop uit je mail, of app ons even.');
      return;
    }
    var url = endpoint('aanvullen') + '?id=' + id + '&token=' + token;
    var form = qs('[data-kv-aanvul-form]', root);
    var titelVeld = qs('[data-kv-aanvul-titelveld]', root);
    var verhaalVeld = qs('[data-kv-aanvul-verhaal]', root);
    var foutEl = qs('[data-kv-aanvul-fout]', root);
    var oorspronkelijkeTitel = '';
    function zetFout(tekst) {
      if (!foutEl) return;
      foutEl.textContent = tekst || '';
      foutEl.hidden = !tekst;
    }
    apiFetch(url).then(function (info) {
      if (!info || typeof info !== 'object') throw KvError('Je inzending kon niet laden. Probeer het zo opnieuw.', 'server');
      var groet = qs('[data-kv-aanvul-groet]', root);
      if (groet && info.voornaam && info.voornaam !== 'Vijverliefhebber') groet.textContent = info.voornaam + ', vertel';
      var titelEl = qs('[data-kv-aanvul-titel]', root);
      if (titelEl) titelEl.textContent = info.titel || 'je vijver';
      var foto = qs('[data-kv-aanvul-foto]', root);
      if (foto && typeof info.foto_url === 'string' && /^https:\/\//.test(info.foto_url)) {
        foto.src = info.foto_url;
        foto.alt = info.titel || 'Je vijver';
        foto.hidden = false;
      }
      if (titelVeld) {
        titelVeld.maxLength = info.max_titel || 120;
        if (info.titel_automatisch) titelVeld.placeholder = info.titel || '';
        else { titelVeld.value = info.titel || ''; oorspronkelijkeTitel = titelVeld.value.trim(); }
      }
      if (verhaalVeld) verhaalVeld.maxLength = info.max_verhaal || 4000;
      var heeft = qs('[data-kv-aanvul-heeft]', root);
      if (heeft) heeft.hidden = !info.heeft_verhaal || !!info.aanvulling_wacht;
      var wacht = qs('[data-kv-aanvul-wacht]', root);
      if (wacht) wacht.hidden = !info.aanvulling_wacht;
      stap('form');
    }).catch(function (err) {
      meet('kv_fout', { kv_bron: 'aanvullen', kv_reden: meetReden(err) });
      fout(err && err.kv ? err.message : 'Je inzending kon niet laden. Probeer het zo opnieuw.');
    });
    root.addEventListener('click', function (e) {
      var start = e.target && e.target.closest ? e.target.closest('[data-kv-aanvul-start]') : null;
      if (!start || !verhaalVeld) return;
      var zin = start.getAttribute('data-kv-aanvul-start');
      var huidig = verhaalVeld.value.replace(/\s+$/, '');
      verhaalVeld.value = huidig ? huidig + '\n' + zin : zin;
      verhaalVeld.focus();
      meet('kv_verhaal_hulp', { kv_bron: 'mail' });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var titel = titelVeld ? titelVeld.value.trim() : '';
      var verhaal = verhaalVeld ? verhaalVeld.value.trim() : '';
      /* Een titel die de klant niet veranderde, sturen we niet opnieuw mee. */
      if (titel && titel === oorspronkelijkeTitel) titel = '';
      if (titel && titel.length < 3) { zetFout('Een titel heeft minimaal 3 tekens, of laat hem leeg.'); return; }
      if (!titel && !verhaal) { zetFout('Schrijf eerst een zin over je vijver.'); return; }
      var knop = qs('button[type="submit"]', form);
      if (knop) { knop.disabled = true; knop.textContent = 'Bezig...'; }
      var body = {};
      if (titel) body.titel = titel;
      if (verhaal) body.verhaal = verhaal;
      apiFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (data) {
        var bericht = qs('[data-kv-aanvul-bericht]', root);
        if (bericht && data && typeof data.bericht === 'string') bericht.textContent = data.bericht;
        window.KlantvijversMeting.verhaalToegevoegd('mail');
        stap('klaar');
        window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      }).catch(function (err) {
        meet('kv_fout', { kv_bron: 'aanvullen', kv_reden: meetReden(err) });
        zetFout(err && err.kv ? err.message : 'Dat lukte niet. Probeer het zo opnieuw.');
      }).finally(function () {
        if (knop) { knop.disabled = false; knop.textContent = 'Zet erbij'; }
      });
    });
  }

  /* ========================= INIT ========================= */
  function init() {
    var galerij = qs('[data-kv-galerij]');
    var insturen = qs('[data-kv-insturen]');
    MEET_PAGINA = galerij ? 'galerij' : (insturen ? 'insturen' : (qs('[data-kv-aanvul]') ? 'aanvul' : 'overig'));
    initVerhaalLater();
    if (galerij) initGalerij(galerij);
    if (insturen) initInsturen(insturen);
    if (insturen) initInsturenPreview(insturen);
    var aanvul = qs('[data-kv-aanvul]');
    if (aanvul) initAanvullen(aanvul);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
